import React, { useRef, useState, useEffect, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    Container,
    Grid,
    Popover,
    Button,
    InputLabel,
    FormControl,
    FormHelperText,
    Input,
    Typography,
    FormControlLabel,
    Checkbox,
    Modal,
    Box,
    Select,
    MenuItem,
    Menu,
    TextField,
    InputAdornment,
    ListItem,
    CircularProgress,
} from "@material-ui/core";
import { styled } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import { toast } from "react-toastify";
import {
    createMemoInvoiceDetails,
    getModelSerialList,
    getBillShipContactList,
    checkContactInDB,
    getNewModelSerialList,
    getInvoiceNewContactList,
    dataTransferBusinessList,
    invoiceDataPush,
} from "../actions/dashboardAction";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import imageNotAvailable from "../../../../assests/images/img-soon.png";
import "../style/style.css";
import Header from "../../../../common/components/Header";
import FooterComponent from "../../../../common/components/Footer";
import { useHistory, useLocation } from "react-router-dom";
import {
    Popover as AntdPopover,
    Input as AntdInput,
    Modal as AntdModal,
} from "antd";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import PropTypes from "prop-types";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import "../../../../common/style/SearchBar.css";
// import {formatPhoneNumber, unformatPhoneNumber} from "../../../../common/components/Helper/Utils";
import { SpinnerRoundFilled } from "spinners-react";
import getUserdetailsforsubscrption from "../../dashboard/actions/dashboardaapi";
import ContactListModal from "./ContactListModal";
import CreateContactDialog from "./CreateContactDialog";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Pricewarining from "./Pricewarining";
import _, { set } from "lodash";
import { event } from "jquery";
import { isValid } from "date-fns";
import { Autocomplete } from "@material-ui/lab";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { isTwoAddressSame, showErrorToast, showSuccessToast } from "../../../../common/components/Helper/Utils";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const { innerWidth: width, innerHeight: height } = window;

const invoiceObj = [
    {
        id: "modelAndSerial",
        label: "Search Model | Serial No | Inventory ID",
        minWidth: 100,
        type: "search",
        required: true,
        errMsg: "Please Enter Model | Serial No | Inventory ID",
    },
    {
        id: "modelNumber",
        label: "Model",
        minWidth: 100,
        type: "search",
        required: false,
        errMsg: "Please Enter Model",
    },
    { id: "image", label: "Image", minWidth: 80, type: "image", required: false },
    {
        id: "serialNumber",
        label: "Serial No",
        minWidth: 80,
        type: "search",
        required: false,
        errMsg: "Please Enter Serial No",
    },
    {
        id: "productName",
        label: "Product Name",
        minWidth: 140,
        type: "text",
        required: false,
    },
    {
        id: "quantity",
        label: "Qty",
        minWidth: 80,
        type: "number",
        required: true,
        errMsg: "Please enter quantity",
    },
    {
        id: "currency",
        label: "Currency",
        minWidth: 30,
        type: "select",
        required: true,
        errMsg: "Please enter rate",
    },
    {
        id: "amount",
        label: "Amount",
        minWidth: 65,
        type: "amount",
        required: true,
        errMsg: "Please Enter Amount",
    },
    { id: "action", label: "Action", minWidth: 70, align: "center" },
];

const billingAddress = [
    {
        id: "billingToName",
        label: "Contact Name",
        minWidth: 80,
        type: "text_search",
        required: true,
        errMsg: "Please enter contact name",
    },
    {
        id: "billingContactType",
        label: "Contact Type",
        minWidth: 80,
        type: "contact_type_select",
        required: false,
        errMsg: "",
    },
    {
        id: "billingToBusinessName",
        label: "Business Name",
        minWidth: 80,
        type: "text",
        required: true,
        errMsg: "",
        isDisabled: true,
    },
    {
        id: "billingToPhoneNo",
        label: "",
        minWidth: 80,
        type: "phone",
        required: true,
        errMsg: "",
        isDisabled: true,
    },
    {
        id: "billingToEmail",
        label: "Email",
        minWidth: 80,
        type: "email",
        required: true,
        errMsg: "Please enter valid email",
        isDisabled: true,
    },
    {
        id: "billingToAddressLine1",
        label: "Address Line1",
        minWidth: 80,
        type: "text",
        required: false,
        errMsg: "",
        isDisabled: true,
    },
    {
        id: "billingToAddressLine2",
        label: "Address Line2",
        minWidth: 80,
        type: "text",
        required: false,
        errMsg: "",
        isDisabled: true,
    },
    {
        id: "billingToCity",
        label: "City",
        minWidth: 80,
        type: "text",
        required: false,
        errMsg: "",
        isDisabled: true,
    },
    {
        id: "billingToCountry",
        label: "Country",
        minWidth: 80,
        type: "select",
        value: "United States",
        required: false,
        errMsg: "",
        isDisabled: true,
    },
    {
        id: "billingToState",
        label: "State",
        minWidth: 80,
        type: "select",
        required: false,
        errMsg: "",
        isDisabled: true,
    },
    {
        id: "billingToZip",
        label: "Zipcode",
        minWidth: 80,
        type: "number",
        required: false,
        errMsg: "",
        isDisabled: true,
    },
];

const shippingAddress = [
    {
        id: "shippingToName",
        label: "Contact Name",
        minWidth: 80,
        type: "text_search",
        required: true,
        errMsg: "Please enter contact name",
    },
    {
        id: "shippingContactType",
        label: "Contact Type",
        minWidth: 80,
        type: "contact_type_select",
        required: false,
        errMsg: "",
    },
    {
        id: "shippingToBusinessName",
        label: "Business Name",
        minWidth: 80,
        type: "text",
        required: true,
        errMsg: "",
        isDisabled: true,
    },
    {
        id: "shippingToPhoneNo",
        label: "",
        minWidth: 80,
        type: "phone",
        required: true,
        errMsg: "",
        isDisabled: true,
    },
    {
        id: "shippingToEmail",
        label: "Email",
        minWidth: 80,
        type: "email",
        required: true,
        errMsg: "Please enter valid email",
        isDisabled: true,
    },
    {
        id: "shippingToAddressLine1",
        label: "Address Line1",
        minWidth: 80,
        type: "text",
        required: false,
        errMsg: "",
        isDisabled: true,
    },
    {
        id: "shippingToAddressLine2",
        label: "Address Line2",
        minWidth: 80,
        type: "text",
        required: false,
        errMsg: "",
        isDisabled: true,
    },
    {
        id: "shippingToCity",
        label: "City",
        minWidth: 80,
        type: "text",
        required: false,
        errMsg: "",
        isDisabled: true,
    },
    {
        id: "shippingToCountry",
        label: "Country",
        minWidth: 80,
        type: "select",
        value: "United States",
        required: false,
        errMsg: "",
        isDisabled: true,
    },
    {
        id: "shippingToState",
        label: "State",
        minWidth: 80,
        type: "select",
        required: false,
        errMsg: "",
        isDisabled: true,
    },
    {
        id: "shippingToZip",
        label: "Zipcode",
        minWidth: 80,
        type: "number",
        required: false,
        errMsg: "",
        isDisabled: true,
    },
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    "&:not(:last-child)": {
        borderBottom: 0,
    },
    "&::before": {
        display: "none",
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === "dark"
            ? "rgba(255, 255, 255, .05)"
            : "rgba(0, 0, 0, .03)",
    flexDirection: "row-reverse",
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
        transform: "rotate(90deg)",
    },
    "& .MuiAccordionSummary-content": {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

function CreateMemoInvoiceComponent(props) {
    const {
        register,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors },
        reset,
        control,
        clearErrors,
        setError,
    } = useForm();
    const {
        register: register1,
        handleSubmit: handleSubmit1,
        setValue: setValue1,
        getValues: getValues1,
        formState: { errors: errors1 },
        watch: watch1,
        reset: reset1,
        setFocus: setFocus1
    } = useForm();

    const location = useLocation();
    const {data, isConvertToSale = false, invoiceFilter } = location.state || {};
    const [dataset, setdataset] = useState([]);
    const [shippingdataset, setshippingdataset] = useState([]);
    const [rows, setRows] = useState([]);
    const [openModal, setModalOpen] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [isSameAddress, setSameAddress] = useState(false);
    const [isOnetimeShippingAddress, setIsOnetimeShippingAddress] = useState(false);
    const [amount, setAmount] = useState(null);
    const [shippingDate, setShippingDate] = useState(null);
    const [memoReturnDate, setMemoReturnDate] = useState(null);
    const [trackingNumber, setTrackingNumber] = useState(null);
    const [notes, setNotes] = useState(null);
    const [shippingMethod, setShippingMethod] = useState(null);
    const [wireDetails, setWireDetails] = useState(true);
    const [invoiceId, setInvoiceId] = useState(null);
    const [shipping, setShipping] = useState(null);
    const [tax, setTax] = useState(null);
    const [fees, setFees] = useState(null);
    const [discount, setDiscount] = useState(null);
    const [deposit, setDeposit] = useState(null);
    const [paymentmethod, setPaymentMethod] = useState(null);
    const [qtyShrink, setQtyShrink] = useState(true);
    const [descShrink, setDescShrink] = useState(false);
    const [editIdx, setEditIdx] = useState(null);
    const [model, setModelList] = useState(props?.modelList);
    const [serialList, setSerialList] = useState([]);
    const [searchObj, setSearchObj] = useState({});
    const [modelNo, setModel] = useState(null);
    const [serial, setSerial] = useState(null);
    const [image, setImage] = useState(null);
    const [desc, setDesc] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [inventoryid, setInventoryId] = useState(null);
    const [productid, setProductId] = useState(null);
    const [noData, setNoData] = useState(false);
    const [noBillData, setNoBillData] = useState(false);
    const [noShipData, setNoShipData] = useState(false);
    const [currentSearch, setCurrentSearch] = useState(null);
    const [isSubmitInvoice, setIsSubmitInvoice] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorTarget, setAnchorTarget] = useState(null);
    const [billCntctNm, setBillCntctNm] = useState(null);
    const [shipCntctNm, setShipCntctNm] = useState(null);
    const [billCntctSearchTxt, setBillCntctSearchTxt] = useState(null);
    const [shipCntctSearchTxt, setShipCntctSearchTxt] = useState(null);
    const [isBillTextInput, setIsBillTextInput] = useState(false);
    const [isShipTextInput, setIsShipTextInput] = useState(false);
    const [billCntcts, setBillCntctLst] = useState([]);
    const [shipCntcts, setShipCntcts] = useState([]);
    const [countryListData, setCountryListData] = useState([]);
    const [statesListData, setStatesListData] = useState([]);
    const [shippingStatesListData, setShippingStatesListData] = useState([]);
    const [contactListConfirmationModal, SetContactListConfirmationModal] =
        useState(false);
    const [createContactModalOpen, setCreateContactModalOpen] = useState(false);
    const [createContactTarget, setCreateContactTarget] = useState("bill");
    const [finalInvoiceData, setFinalInvoiceData] = useState(null);
    const [shippingCountryCode, setShippingCountryCode] = useState("+1");
    const [billingCountryCode, setBillingCountryCode] = useState("+1");
    const [modalText, setModalText] = useState(
        "This is not in your contacts, Do you want to save it?"
    );
    const [UniqueCountryCode, setUniqueCountryCode] = useState([]);
    const [currency, setCurrency] = useState("USD");
    // const[openpricewarning,setopenpricewarning]=useState(false);
    const [onsubmitdata, setonsubmitdata] = useState("");
    const [purchaseprice, setpurchaseprice] = useState("");
    const [price, setprice] = useState(null);
    const [isPopoverVisiblebill, setIsPopoverVisiblebill] = useState(false);
    const [isPopoverVisibleship, setIsPopoverVisibleship] = useState(false);
    const [searchInput, setSearchInput] = useState("");
    const [searchInputship, setSearchInputship] = useState("");
    const [isPopoverVisiblemodelno, setIsPopoverVisiblemodelno] = useState(false);
    const [isPopoverVisibleserialno, setIsPopoverVisibleserialno] =
        useState(false);
    const [searchInputmodelno, setSearchInputmodelno] = useState("");
    const [searchInputserialno, setSearchInputserialno] = useState("");
    const [isSerialNumberRequired, setISSerialNumberRequired] = useState(false);
    const [paymentdetails, setPaymentDetails] = useState(null);
    const [type, setType] = useState(null);
    const [zelleDetails, setZelleDetails] = useState(false);
    const [venmoDetails, setVenmoDetails] = useState(false);
    const [shippingDetails, setShippingDetails] = useState(true);
    const userId = props?.currentUser?.userId ? props?.currentUser?.userId : null;
    // const accountId = props?.currentUser?.accountId ? props?.currentUser?.accountId : null;
    const accountId = window.sessionStorage.getItem("accountId");
    const userDetails = window.sessionStorage.getItem("userDetails")
        ? JSON.parse(window.sessionStorage.getItem("userDetails"))
        : null;
    const loggedInAccountId = userDetails?.accountId || userDetails?.accountid || accountId;
    const accountIds =
        userDetails?.accountdetails?.map(acc => acc.accountid) || [];
    const history = useHistory();
    const inputRef = useRef(null);
    const shipinputRef = useRef(null);
    const modelinputRef = useRef(null);
    const serialinputRef = useRef(null);
    const [disabled, setDisabled] = useState(false);
    const [invoiceListData, setInvoiceListData] = useState([]);
    const [fieldLoaderBill, setFieldLoaderBill] = useState(null);
    const [fieldLoaderShip, setFieldLoaderShip] = useState(null);
    const [walkInValidationError, setWalkInValidationError] = useState("");
    const [contactTypeBill, setContactTypeBill] = useState(['business_client', 'end_customer']);
    const [contactTypeShip, setContactTypeShip] = useState(['business_client', 'end_customer']);
    const [classificationTypeBill, setClassificationTypeBill] = useState(["supplier", "memo_supplier", "partner"]);
    const [classificationTypeShip, setClassificationTypeShip] = useState(["supplier", "memo_supplier", "partner"]);
    const [billContactId, setBillContactId] = useState(null);
    const [shipContactId, setShipContactId] = useState(null);
    const [billDealerAccountId, setBillDealerAccountId] = useState(null);
    const [billDealerUserId, setBillDealerUserId] = useState(null);
    const [billContactSearchType, setBillContactSearchType] = useState("other_option");
    const [shipContactSearchType, setShipContactSearchType] = useState("other_option");
    const [billMenuOpen, setBillMenuOpen] = useState(false);
    const [dealerListBill, setDealerListBill] = useState([]);
    const [dealerListShip, setDealerListShip] = useState([]);
    const [isPopoverVisibleDealerBill, setIsPopoverVisibleDealerBill] = useState(false);
    const [isPopoverVisibleDealerShip, setIsPopoverVisibleDealerShip] = useState(false);
    const [fieldLoaderDealerBill, setFieldLoaderDealerBill] = useState(false);
    const [fieldLoaderDealerShip, setFieldLoaderDealerShip] = useState(false);
    const [isBillFieldsEditable, setIsBillFieldsEditable] = useState(false);
    const [isShipFieldsEditable, setIsShipFieldsEditable] = useState(false);
    const open = Boolean(anchorEl);
    const [shipAnchorEl, setShipAnchorEl] = useState(null);
    const shipOpen = Boolean(shipAnchorEl); 
    const [dealerPushConfirmOpen, setDealerPushConfirmOpen] = useState(false);
    const [createdInvoiceId, setCreatedInvoiceId] = useState(null);
    const [contactValidationError, setContactValidationError] = useState("");
    const [shipContactValidationError, setShipContactValidationError] = useState("");
    const [billDealerSearched, setBillDealerSearched] = useState(false);    
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleShipClick = (event) => {       
        setShipAnchorEl(event.currentTarget);
    };
    useEffect(() => {
        if (props?.location?.state?.inventoryDetails) {
            setInventoryId(props?.location?.state?.inventoryDetails?.inventoryid);
            setRows([
                {
                    modelNumber: props?.location?.state?.inventoryDetails?.model,
                    serialNumber: props?.location?.state?.inventoryDetails?.serialno,
                    productName: props?.location?.state?.inventoryDetails?.desc,
                    image: props?.location?.state?.inventoryDetails?.image,
                    inventoryId: props?.location?.state?.inventoryDetails?.inventoryid,
                    productId: props?.location?.state?.inventoryDetails?.productid,
                    quantity: props?.location?.state?.inventoryDetails?.quantity
                        ? props?.location?.state?.inventoryDetails?.quantity
                        : 1,
                    amount: "",
                    currency: currency,
                    type: props?.location?.state?.inventoryDetails?.type,
                },
            ]);
            const currentRow = {
                amount: "",
                image: props?.location?.state?.inventoryDetails?.image,
                modelNumber: props?.location?.state?.inventoryDetails?.model,
                productName: props?.location?.state?.inventoryDetails?.desc,
                quantity: props?.location?.state?.inventoryDetails?.quantity
                    ? props?.location?.state?.inventoryDetails?.quantity
                    : 1,
                serialNumber: props?.location?.state?.inventoryDetails?.serialno,
                inventoryId: props?.location?.state?.inventoryDetails?.inventoryid,
                productId: props?.location?.state?.inventoryDetails?.productid,
                from: "inventory",
                currency: currency,
                type: props?.location?.state?.inventoryDetails?.type,
                inventoryid: props?.location?.state?.inventoryDetails?.inventoryid,
            };
            setAnchorEl(null);
            setCurrentItem(currentRow);
            reset(currentRow);
            setEditIdx(0);
            setModel(props?.location?.state?.inventoryDetails?.model);
            setSerial(props?.location?.state?.inventoryDetails?.serialno);
            setProductId(props?.location?.state?.inventoryDetails?.productid);
            setprice(props?.location?.state?.inventoryDetails?.purchaseprice);
            setInventoryId(props?.location?.state?.inventoryDetails?.inventoryid);
            setQuantity(
                props?.location?.state?.inventoryDetails?.quantity
                    ? props?.location?.state?.inventoryDetails?.quantity
                    : 1
            );
            setType(
                props?.location?.state?.inventoryDetails?.type
                    ? props?.location?.state?.inventoryDetails?.type
                    : null
            );
            if (props?.location?.state?.inventoryDetails?.desc) {
                setDescShrink(true);
            }
            setModalOpen(!openModal);
            setDisabled(true);
        } else {
            setInventoryId(null);
        }
        getcountryList();
    }, [props?.location?.state?.inventoryDetails]);

    const getcountryList = () => {
        getUserdetailsforsubscrption.getAllCountryList().then((res) => {
            setCountryListData(res?.data?.data);
            let countries = res?.data?.data;
            let countryCode = [];
            countries.filter(({ phonecode }) => countryCode.push(phonecode));
            const UniqueCountryCode = [...new Set(countryCode)];
            setUniqueCountryCode(UniqueCountryCode.sort());
        });
        // us States List 231
        getUserdetailsforsubscrption.getAllStateList(231).then((res) => {
            setStatesListData(res.data.data);
            setShippingStatesListData(res.data.data);
        });
    };
    const selectedRows = isConvertToSale ? rows.filter(r => r.checked) : rows;

    const isStateChanged = watch1('billingToState') || watch1('shippingToState')
        || watch1("billingToZip") || watch1("shippingToZip");
    useEffect(() => {
        const updatedValues = getValues1();
    }, [isStateChanged]);

    const onCreateInvoiceSubmit = (formData) => {
        // if (!(formData?.billingToName || formData?.shippingToName || billContactId || shipContactId || (billDealerAccountId && billDealerUserId))) {
        //     return false;
        // }
        const isBillContactMissing =
            !formData?.billingToName ||
            (billContactSearchType === "other_option" && !billContactId) ||
            (billContactSearchType === "dealer" && !(billDealerAccountId && billDealerUserId));

        const isShipContactMissing =
            !isSameAddress &&
            !isOnetimeShippingAddress &&
            (!formData?.shippingToName ||
                (shipContactSearchType === "other_option" && !shipContactId) ||
                (shipContactSearchType === "dealer" && !shipContactId));

        if (isBillContactMissing || isShipContactMissing) {
            setContactValidationError(
                isBillContactMissing ? "Please select atleast one contact to proceed?" : ""
            );
            setShipContactValidationError(
                isShipContactMissing ? "Please select atleast one contact to proceed?" : ""
            );
            setIsSubmitInvoice(false);
            window.scrollTo({ top: 0, behavior: "smooth" });
            return false;
        }
        setContactValidationError("");
        setShipContactValidationError("");
        const normalize = (v) => (v || "").toString().trim().toLowerCase();
        const isBillNewWalkIn = billContactSearchType === "walk_in" && !billContactId;
        const isShipNewWalkIn = shipContactSearchType === "walk_in" && !shipContactId;
        if (isBillNewWalkIn && isShipNewWalkIn) {
            const sameEmail = normalize(formData?.billingToEmail) === normalize(formData?.shippingToEmail);
            const samePhone =
                (normalize(billingCountryCode) + normalize(formData?.billingToPhoneNo)) ===
                (normalize(shippingCountryCode) + normalize(formData?.shippingToPhoneNo));
            const sameContactName = normalize(formData?.billingToName) === normalize(formData?.shippingToName);
            const sameBusinessName = normalize(formData?.billingToBusinessName) === normalize(formData?.shippingToBusinessName);

            if (sameEmail && samePhone && (!sameContactName || !sameBusinessName)) {
                const msg = "The same email address and phone number cannot be used with a different Customer Name or Business Name across Bill To and Ship To. Please use the same Customer Name and Business Name, or provide a different email address or phone number.";
                setWalkInValidationError(msg);
                setIsSubmitInvoice(false);
                return false;
            }
            setWalkInValidationError("");
        }
        if (billContactSearchType === "dealer" && !(billContactId || (billDealerAccountId && billDealerUserId))) {
            return false;
        }
        if (!isSameAddress && !isOnetimeShippingAddress && shipContactSearchType === "dealer" && !shipContactId) {
            return false;
        }
        if (isOnetimeShippingAddress && !isSameAddress) {
            const shipName = (formData?.shippingToName || "").toString().trim();
            const shipAddress1 = (formData?.shippingToAddressLine1 || "")
                .toString()
                .trim();
            const shipAddress2 = (formData?.shippingToAddressLine2 || "")
                .toString()
                .trim();
            const shipCity = (formData?.shippingToCity || "").toString().trim();
            const shipState = (formData?.shippingToState || "").toString().trim();
            const shipCountry = (formData?.shippingToCountry || "").toString().trim();

            if (!shipName) {
                showErrorToast("Please enter the contact name for one-time shipping.");
                setIsSubmitInvoice(false);
                return false;
            }
            if (!shipAddress1 && !shipAddress2) {
                showErrorToast(
                    "Please enter Address Line 1 or Address Line 2 for one-time shipping.",
                );
                setIsSubmitInvoice(false);
                return false;
            }
            if (!shipCity) {
                showErrorToast("Please enter City for one-time shipping.");
                setIsSubmitInvoice(false);
                return false;
            }
            if (!shipState) {
                showErrorToast("Please select State for one-time shipping.");
                setIsSubmitInvoice(false);
                return false;
            }
            if (!shipCountry) {
                showErrorToast("Please select Country for one-time shipping.");
                setIsSubmitInvoice(false);
                return false;
            }
        }
        setIsSubmitInvoice(true);
        let imageNotAvailable = isConvertToSale 
        ? rows?.filter(row => row.checked).map(row => ({ ...row, image: [] }))
        : rows?.map(row => ({ ...row, image: [] }));
        const useDealerOnly = billContactSearchType === "dealer" && !billContactId && !shipContactId;
        const data = {
            userId: userId,
            accountid: accountId,
            billingcontactid: billContactSearchType === "dealer" ? null : billContactId,
            shippingcontactid:
                isOnetimeShippingAddress && !isSameAddress
                    ? null
                    : shipContactSearchType === "dealer" ? null : isSameAddress ? billContactId : shipContactId,
            billingToBusinessName: formData?.billingToBusinessName,
            billingToName: formData?.billingToName,
            billingToAddressLine1: formData?.billingToAddressLine1,
            billingToAddressLine2: formData?.billingToAddressLine2
                ? formData?.billingToAddressLine2
                : "",
            billingToPhoneNo: formData?.billingToPhoneNo
                ? formData?.billingToPhoneNo
                : null,
            billingToCountryCode: billingCountryCode,
            billingToEmail: formData?.billingToEmail,
            billingToCity: formData?.billingToCity,
            billingToState: formData?.billingToState,
            billingToCountry: formData?.billingToCountry,
            billingToZip: formData?.billingToZip,
            is_include_dealercontact:
                billContactSearchType === "dealer" || shipContactSearchType === "dealer",
            ...(billContactSearchType === "dealer"
                ? { billing_dealercontact_accountid: billDealerAccountId, 
                    billing_dealercontact_userid: billDealerUserId }
                : {}),
            is_include_temp_walkin_contact: billContactSearchType === "walk_in",
            is_include_temp_walkin_contact_ship:
                !isSameAddress &&
                !isOnetimeShippingAddress && shipContactSearchType === "walk_in" && !shipContactId,
            billing_contact_type: CONTACT_TYPE_MAP[billContactSearchType] || "retail",
            shipping_contact_type: CONTACT_TYPE_MAP[shipContactSearchType] || "retail",
            shippingToBusinessName: formData?.shippingToBusinessName,
            shippingToName: formData?.shippingToName,
            shippingToAddressLine1: formData?.shippingToAddressLine1,
            shippingToAddressLine2: formData?.shippingToAddressLine2
                ? formData?.shippingToAddressLine2
                : "",
            shippingToPhoneNo: formData?.shippingToPhoneNo
                ? formData?.shippingToPhoneNo
                : null,
            shippingToCountryCode: shippingCountryCode,
            shippingToEmail: formData?.shippingToEmail,
            shippingToCity: formData?.shippingToCity,
            shippingToState: formData?.shippingToState,
            shippingToCountry: formData?.shippingToCountry,
            shippingToZip: formData?.shippingToZip,
            productDetails: JSON.stringify(imageNotAvailable),
            shippingPrice: formData?.shippingPrice
                ? formatPrice(formData?.shippingPrice)
                : "0.00",
            discount: formData?.discount ? formatPrice(formData?.discount) : "0.00",
            tax: formData?.tax ? formatPrice(formData?.tax) : "0.00",
            fees: formData?.fees ? formatPrice(formData?.fees) : "0.00",
            deposit: formData?.deposit ? formatPrice(formData?.deposit) : "0.00",
            memoterm: formData?.terms,
            memo_returndate: memoReturnDate,
            paymentMethod: paymentmethod,
            paymentmethod_details: paymentdetails,
            shippingMethod: formData?.shippingMethod,
            shippingDate: shippingDate,
            trackingNumber: formData?.trackingNumber,
            notes: notes,
            wireDetails: wireDetails,
            zelleDetails: zelleDetails,
            venmoDetails: venmoDetails,
            shippingDetails: shippingDetails,
            isSameAddress: isSameAddress,
            isOnetimeShippingAddress: isSameAddress ? false : isOnetimeShippingAddress,
            is_onetime_shipping_address: isSameAddress ? false : isOnetimeShippingAddress,
        };
        createNewInvoiceAPI(data);
    };

    const handleCloseContactConfirmation = () => {
        setFinalInvoiceData(null);
        SetContactListConfirmationModal(!contactListConfirmationModal);
        createNewInvoiceAPI(finalInvoiceData);
    };

    const CONTACT_TYPE_MAP = {
        other_option: "retail",
        walk_in: "walkin",
        dealer: "dealer",
    };

    const handleSuccessContactConfirmation = () => {
        const data = finalInvoiceData;
        const filterObject = data.filterData;
        setFinalInvoiceData(null);
        SetContactListConfirmationModal(!contactListConfirmationModal);
        filterObject.map((item) => {
            if (!item.isPresent) {
                if (item.type === "billing") {
                    data["isBillNew"] = 1;
                } else {
                    data["isShipNew"] = 1;
                }
            } else {
                if (item.isChanged && isSameAddress) {
                    data["isBillChanged"] = 1;
                    data["isShipChanged"] = 1;
                } else if (item.isChanged) {
                    if (item.type === "billing") {
                        data["isBillChanged"] = 1;
                    } else {
                        data["isShipChanged"] = 1;
                    }
                } else {
                    data.isChanged = 0;
                }
            }
        });
        createNewInvoiceAPI(data);
    };

    useEffect(() => {
        if (invoiceId !== null) {
            localStorage.setItem("tabInvoiceDashboard", "yes");
            props.history.push({
                pathname: "/view/invoice",
                state: { tab: "invoice", invoiceId, isMemo: true, invoiceFilter },
            });
            localStorage.removeItem("tabInvoiceDashboard", true);
        }
    }, [invoiceId, props.history]);

    const createNewInvoiceAPI = (data) => {
        if (data && data.filterData) delete data.filterData;
        props.createMemoInvoiceDetails(
            data,
            (success) => {
                if (success?.status === 1) {
                    setIsSubmitInvoice(false);
                    localStorage.setItem("menuTitle", "INVOICES");
                    toast("Memo Invoice created successfully", {
                        autoClose: 1000,
                        type: success.status === 1 ? toast.TYPE.SUCCESS : toast.TYPE.ERROR,
                        position: toast.POSITION.BOTTOM_CENTER,
                    });
                    const isDealerFlow =
                        billContactSearchType === "dealer" || shipContactSearchType === "dealer";
                    if (isDealerFlow) {
                        setCreatedInvoiceId(success.data.id);
                        setDealerPushConfirmOpen(true);
                    } else {
                        setTimeout(() => {
                            setInvoiceId(success.data.id);
                        }, 1000);
                    }
                } else {
                    setIsSubmitInvoice(false);
                    toast(success.message, {
                        autoClose: 3000,
                        type: toast.TYPE.ERROR,
                        position: toast.POSITION.BOTTOM_CENTER,
                    });
                }
            }
        );
    };
    const formatPrice = (val) => {
        if (val.includes(".")) {
            if (val.split(".")[1].length > 0) {
                const num = parseFloat(val);
                const cleanNum = num.toFixed(2);
                return cleanNum.toString();
            }
        }
        return `${val}.00`;
    };

    const handleAddRow = (invoiceObj) => {
        if (currentItem) {
            let oldRows = rows;
            oldRows[editIdx] = invoiceObj;
            setRows(oldRows);
        } else {
            setRows((prevArray) => [...prevArray, invoiceObj]);
        }
    };

    const onSubmit = (data) => {
        if (type !== "misc_product" && isSerialNumberRequired) {
            errors["serialNumber"] = {
                message: "Please Enter Serial No",
                type: "required",
            };
            return;
        }
        if ((price && Number(price) < amount) || !price) {
            setModalOpen(false);
            // setopenpricewarning(false);
        } else {
            toast("This sale is under cost", {
                autoClose: 2000,
                type: toast.TYPE.ERROR,
                position: toast.POSITION.BOTTOM_CENTER,
            });
            setModalOpen(false);
        }

        const amt = parseFloat(data.amount)?.toFixed(2);
        const rowData = data;
        rowData.amount = amt;
        rowData.inventoryId = inventoryid;
        rowData.productId = productid;
        rowData.currency = currency;
        rowData.purchaseprice = price;
        rowData.type = type;
        if (rowData && rowData.from) {
            delete rowData.from;
        }
        handleAddRow({
            ...rowData,
            ...{ modelNumber: modelNo },
            ...{ serialNumber: serial },
            ...{ productName: desc || getValues("productName") },
        });
        setpurchaseprice(null);
        setprice(null);
    };
    const onSubmitone = () => {
        setModalOpen(false);
        const amt = parseFloat(onsubmitdata.amount)?.toFixed(2);
        const rowData = onsubmitdata;
        rowData.amount = amt;
        rowData.inventoryId = inventoryid;
        rowData.productId = productid;
        rowData.currency = currency;
        rowData.purchaseprice = price;
        if (rowData && rowData.from) {
            delete rowData.from;
        }
        handleAddRow({
            ...rowData,
            ...{ modelNumber: modelNo },
            ...{ serialNumber: serial },
            ...{ productName: desc || getValues("productName") },
        });
        setpurchaseprice(null);
        setprice(null);
    };

    const handleSameaddressCheck = (event) => {
        setSameAddress(!isSameAddress);
        if (event.target.checked) {
            setIsOnetimeShippingAddress(false);
            shippingAddress.map((item, i) => {
                setValue1(item.id, getValues1()[billingAddress[i].id]);
            });
            setValue1("shippingToName", billCntctNm);
            setShippingCountryCode(billingCountryCode);
            setShipCntctNm(billCntctNm);
            setShipContactId(billContactId);
            setShipContactSearchType(billContactSearchType);
            setContactTypeShip(contactTypeBill);
            setIsShipFieldsEditable(isBillFieldsEditable);
        } else {
            setNoShipData(false);
            setShipCntctSearchTxt(null);
            setShipCntctNm(null);
            setShipContactId(null);
            setShipContactSearchType("business");
            setContactTypeShip(["business_client", "end_customer"]);
            setIsShipFieldsEditable(false);
            shippingAddress.map((item, i) => {
                setValue1(item.id, "");
            });
        }
    };

    useEffect(() => {
        if (isSameAddress) {
            setIsOnetimeShippingAddress(false);
            shippingAddress.map((item, i) => {
                setValue1(item.id, getValues1()[billingAddress[i].id]);
            });
            setValue1("shippingToName", billCntctNm);
            setShippingCountryCode(billingCountryCode);
            setShipCntctNm(billCntctNm);
            setShipContactSearchType(billContactSearchType);
            setContactTypeShip(contactTypeBill);
            setIsShipFieldsEditable(isBillFieldsEditable);
        } else if (!isOnetimeShippingAddress) {
            setNoShipData(false);
            setShipCntctSearchTxt(null);
            setShipCntctNm(null);
            shippingAddress.map((item, i) => {
                setValue1(item.id, "");
            });
        }
    }, [isSameAddress, billContactSearchType]);

    const destructureData = (data) => {
        const groupedByEmail = {};
        data.forEach((value) => {
            const Email = value.email;
            groupedByEmail[Email] = groupedByEmail[Email] || [];
            groupedByEmail[Email].push(value);
        });
        const resultArray = Object.values(groupedByEmail);
        return resultArray;
    };

    useEffect(() => {
        if (props.billShipCntctLst && props.billShipCntctLst?.length > 0) {
            if (billCntctSearchTxt) {
                const filteredData = destructureData(props.billShipCntctLst);
                setdataset(filteredData);
                setBillCntctLst(props.billShipCntctLst);
                setShipCntcts(null);
                setIsPopoverVisiblebill(!false);
                setNoBillData(false);
                if (billContactSearchType === "walk_in") {
                    setIsBillFieldsEditable(false);
                }
            }
            if (shipCntctSearchTxt) {
                const filteredData = destructureData(props.billShipCntctLst);
                setshippingdataset(filteredData);
                setShipCntcts(props.billShipCntctLst);
                setIsPopoverVisibleship(!false);
                setNoShipData(false);
                if (shipContactSearchType === "walk_in") {
                    setIsShipFieldsEditable(false);
                }
            }
        } else if (props.billShipCntctLst?.length === 0) {
            if (billCntctSearchTxt) {
                setBillCntctLst([]);
                setNoBillData(true);
                setdataset([]);
                if (billContactSearchType === "walk_in") {
                    setIsBillFieldsEditable(true);
                }
            }
            if (shipCntctSearchTxt) {
                setShipCntcts([]);
                setNoShipData(true);
                setshippingdataset([]);
                if (shipContactSearchType === "walk_in") {
                    setIsShipFieldsEditable(true);
                }
            }
        }
    }, [props.billShipCntctLst]);

    useEffect(() => {
        if (props.modelList && props.modelList?.length > 0) {
            if (modelNo) {
                setModelList(props.modelList);
                setIsPopoverVisiblemodelno(true);
                setNoData(false);
            }
            if (serial) {
                setSerialList(props.modelList);
                setIsPopoverVisibleserialno(true);
                setNoData(false);
            }
        } else {
            if (searchObj?.searchVal?.length > 2) {
                setNoData(true);
            }
        }
    }, [props.modelList, modelNo, serial]);
    useEffect(() => {
        const timer = setTimeout(() => {
            if (Object.keys(searchObj).length && searchObj?.searchVal?.length > 2) {
                props.getNewModelSerialList(searchObj, accountId);
            }
        }, 500);
        return () => clearTimeout(timer);
    }, [searchObj]);

    const handleAddItem = () => {
        setModalOpen(!openModal);
        setCurrentItem(null);
        setShippingDate(null);
        setMemoReturnDate(null);
        setAmount(null);
        setInventoryId(null);
        setProductId(null);
        setCurrency("USD");
        setQtyShrink(true);
        setDescShrink(false);
        setEditIdx(null);
        setModel(null);
        setSerial(null);
        setDesc(null);
        setNoData(false);
        setQuantity(1);
        setType(null);
        reset({
            modelNumber: "",
            serialNumber: "",
            image: "",
            productName: "",
            quantity: 1,
            amount: "",
            inventoryId: "",
            productId: "",
            currency: "USD",
            modelAndSerial: null,
        });
    };

    const handleClosepriceModal = () => {
    };

    const handleCloseModal = () => {
        setModalOpen(false);

        if (currentItem && currentItem.from) {
            handleRemoveSpecificRow(0);
        }
    };

    const handleRemoveSpecificRow = (idx) => {
        setEditIdx(null);
        const temp = [...rows];
        temp.splice(idx, 1);
        if (temp.length === 0) {
            setShipping(null);
            setDeposit(null);
            setTax(null);
            setFees(null);
            setDeposit(null);
            setQuantity(1);
            setType(null);
            setISSerialNumberRequired(false);
        }
        setRows(temp);
    };

    const onChangeOfCheckBox = (event) => {
        if (event.target.checked === true) {
            setWireDetails(true);
        } else {
            setWireDetails(false);
        }
    };

    const onChangeOfCheckBoxZelle = (event) => {
        if (event.target.checked === true) {
        setZelleDetails(true);
        } else {
        setZelleDetails(false);
        }
    };
    const onChangeOfCheckBoxVenmo = (event) => {
        if (event.target.checked === true) {
        setVenmoDetails(true);
        } else {
        setVenmoDetails(false);
        }
    };
    const onChangeOfCheckBoxShipping = (event) => {
        if (event.target.checked === true) {
        setShippingDetails(true);
        } else {
        setShippingDetails(false);
        }
    };

    const handleSearch = (e, column) => {
        setNoData(false);
        const modelNmTrim = e.target.value.trimStart();
        setCurrentSearch(column);
        if (column === "modelNumber") {
            setModel(e.target.value);
            setSearchInputmodelno(modelNmTrim);
        } else {
            setSerial(modelNmTrim.length === 0 ? null : e.target.value);
            setSearchInputserialno(modelNmTrim);
            if (type !== "misc_product" && modelNmTrim.length === 0) {
                setISSerialNumberRequired(true);
            } else {
                setISSerialNumberRequired(false);
            }
        }
        setSearchObj({ column, searchVal: e.target.value });
    };

    const handleVisibleChange = (visible) => {
        setIsPopoverVisiblebill(visible);
    };
    const handleVisibleChangeship = (visible) => {
        setIsPopoverVisibleship(visible);
    };

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
        if (shipinputRef.current) {
            shipinputRef.current.focus();
        }
        if (modelinputRef.current) {
            modelinputRef.current.focus();
        }
        if (serialinputRef.current) {
            serialinputRef.current.focus();
        }
        getInvoiceList();
    }, []);

    const getInvoiceList = () => {
        getUserdetailsforsubscrption.getAllInvoiceList(
            accountId,
            (error, response) => {
                if (response && response.status == 1) {
                    setInvoiceListData(response.data);
                }
            }
        );
    };

    const fetchBillContacts = useCallback(
        _.debounce((searchText) => {
            if (!isBillTextInput && searchText && searchText.length > 2) {
                setFieldLoaderBill(true);
                let payload = {
                    key: searchText,
                    contacttype: contactTypeBill,
                    type: null,
                    accountids: accountIds,
                };
                props
                    .getInvoiceNewContactList(payload)
                    .then(() => setFieldLoaderBill(false))
                    .catch(() => setFieldLoaderBill(false));
            }
        }, 500),
        [isBillTextInput, contactTypeBill, accountId, props]
    );

    useEffect(() => {
        if (billContactSearchType !== "dealer") {
            fetchBillContacts(billCntctSearchTxt);
        }
    }, [billCntctSearchTxt, billContactSearchType]);

    const fetchShipContacts = useCallback(
        _.debounce((searchText) => {
            if (!isShipTextInput && searchText && searchText.length > 2) {
                setFieldLoaderShip(true);
                let payload = {
                    key: searchText,
                    contacttype: contactTypeShip,
                    type: null,
                    accountids: accountIds,
                };
                props
                    .getInvoiceNewContactList(payload)
                    .then(() => setFieldLoaderShip(false))
                    .catch(() => setFieldLoaderShip(false));
            }
        }, 500),
        [isShipTextInput, contactTypeShip, accountId, props]
    );

    useEffect(() => {
        if (shipContactSearchType !== "dealer" && !isOnetimeShippingAddress) {
            fetchShipContacts(shipCntctSearchTxt);
        }
    }, [shipCntctSearchTxt, shipContactSearchType, isOnetimeShippingAddress]);

    const fetchBillDealers = useCallback(
        _.debounce((searchText) => {
            if (searchText && searchText.length > 2) {
                setFieldLoaderDealerBill(true);
                setBillDealerSearched(false);
                setIsPopoverVisibleDealerBill(true);
                const handleSuccess = (success) => {
                    const list = Array.isArray(success)
                        ? success
                        : success?.data?.data || success?.data || success || [];
                    setDealerListBill(Array.isArray(list) ? list : []);
                    setFieldLoaderDealerBill(false);
                    setBillDealerSearched(true);
                };
                const handleError = (error) => {
                    setDealerListBill([]);
                    setFieldLoaderDealerBill(false);
                    setBillDealerSearched(true);
                };
                const result = props.dataTransferBusinessList(
                    searchText,
                    handleSuccess,
                    handleError
                );
                if (result && typeof result.then === "function") {
                    result.then(handleSuccess).catch(handleError);
                }
            } else {
                setIsPopoverVisibleDealerBill(false);
                setBillDealerSearched(false);
            }
        }, 500),
        [accountId]
    );

    useEffect(() => {
        if (billContactSearchType === "dealer") {
            fetchBillDealers(billCntctSearchTxt);
        }
    }, [billCntctSearchTxt, billContactSearchType]);

    const fetchShipDealers = useCallback(
        _.debounce((searchText) => {
            if (searchText && searchText.length > 2) {
                setFieldLoaderDealerShip(true);
                setIsPopoverVisibleDealerShip(true);
                const handleSuccess = (success) => {
                    const list = Array.isArray(success)
                        ? success
                        : success?.data?.data || success?.data || success || [];
                    const filteredList = Array.isArray(list)
                        ? list.filter((item) => String(item?.accountid) !== String(loggedInAccountId))
                        : [];
                    setDealerListShip(filteredList);
                    setFieldLoaderDealerShip(false);
                };
                const handleError = (error) => {
                    setDealerListShip([]);
                    setFieldLoaderDealerShip(false);
                };
                const result = props.dataTransferBusinessList(
                    searchText,
                    handleSuccess,
                    handleError
                );
                if (result && typeof result.then === "function") {
                    result.then(handleSuccess).catch(handleError);
                }
            } else {
                setIsPopoverVisibleDealerShip(false);
            }
        }, 500),
        [accountId, props]
    );

    useEffect(() => {
        if (shipContactSearchType === "dealer" && !isOnetimeShippingAddress) {
            fetchShipDealers(shipCntctSearchTxt);
        }
    }, [shipCntctSearchTxt, shipContactSearchType, isOnetimeShippingAddress]);

    const handleContactSearch = (e, column, type) => {
        const CntctNmTrim = e.target.value.trimStart();
        if (type === "bill") {
            setContactValidationError("");
        } else if (type === "ship") {
            setShipContactValidationError("");
        }
        if (type === "bill" && column === "billingToName") {
            setBillCntctNm(CntctNmTrim);
            setSearchInput(CntctNmTrim.trim());
            setBillCntctSearchTxt(CntctNmTrim);
            setShipCntctSearchTxt(null);
            setValue1("billingToName", CntctNmTrim);
            if (billContactSearchType === "walk_in") {
                setIsBillFieldsEditable(true);
            }
        } else if (type === "ship" && column === "shippingToName") {
            setShipCntctNm(CntctNmTrim);
            setSearchInputship(CntctNmTrim.trim());
            setShipCntctSearchTxt(CntctNmTrim);
            setBillCntctSearchTxt(null);
            setValue1("shippingToName", CntctNmTrim);
            if (isOnetimeShippingAddress) {
                setIsShipFieldsEditable(true);
            } else if (shipContactSearchType === "walk_in") {
                setIsShipFieldsEditable(true);
            }
        }
        if (type === "bill" && isSameAddress) {
            const changeColum = column.split("billing")[1];
            setValue1(`shipping${changeColum}`, CntctNmTrim);
            if (column === "billingToName") {
                setShipCntctNm(CntctNmTrim);
            }
        }
    };

    const handleContactTypeChange = (event, type) => {
        const { value, checked } = event.target;
        if (type === "bill") {
            setContactTypeBill((prev) =>
                checked ? [...prev, value] : prev.filter((type) => type !== value)
            );
            setClassificationTypeBill((prev) => checked ? null : prev);
        }
        else if (type === "ship") {
            setContactTypeShip((prev) =>
                checked ? [...prev, value] : prev.filter((type) => type !== value)
            );
            setClassificationTypeShip((prev) => checked ? null : prev);
        }
    };

    const handleBillSearchTypeMenu = (e) => {
        e.stopPropagation();
        setBillMenuOpen((prev) => !prev);
    };

    const handleContactSearchTypeChange = (value, side) => {
        if (side === "bill") {
            setBillContactSearchType(value);
            setContactTypeBill(value === "walk_in" ? ["walk_in"] : ["business_client", "end_customer"]);
            setIsBillFieldsEditable(false);
            clearCntctSearchInput("bill");
            setDealerListBill([]);
            setIsPopoverVisibleDealerBill(false);
        } else {
            setIsOnetimeShippingAddress(false);
            setShipContactSearchType(value);
            setContactTypeShip(value === "walk_in" ? ["walk_in"] : ["business_client", "end_customer"]);
            setIsShipFieldsEditable(false);
            clearCntctSearchInput("ship");
            setDealerListShip([]);
            setIsPopoverVisibleDealerShip(false);
        }
    };

    const handleDealerSelection = (val, side) => {
        const dealerName = val?.businessname || val?.dealername || val?.name || `${val?.firstname ?? ""} ${val?.lastname ?? ""}`.trim();
        let phoneNumber = val ? val.phoneno : null;
        phoneNumber = phoneNumber ? phoneNumber.replace(/\W+/g, "") : null;
        const dealerId = val?.accountid || val?.contactid;

         const refreshStatesFor = (countryName, setter) => {
            if (!countryName) return;
            const filterCountry = countryListData.find((country) => country.name === countryName);
            if (filterCountry && filterCountry.id) {
                getUserdetailsforsubscrption
                    .getAllStateList(filterCountry.id)
                    .then((res) => setter(res?.data?.data))
                    .catch((error) => showErrorToast(error || "Something went wrong"));
            }
        };

        if (side === "bill") {
            setBillCntctNm(dealerName);
            setBillContactId(dealerId);
            setBillDealerAccountId(val?.accountid || val?.contactid || null);
            setBillDealerUserId(val?.userid || null);
            setBillingCountryCode(val?.phone ? val?.countrycode || "" : "");
            setValue1("billingToName", dealerName);
            setValue1("billingToBusinessName", val?.businessname);
            setValue1("billingToPhoneNo", val?.phone);
            setValue1("billingToEmail", val?.email);
            setValue1("billingToAddressLine1", val?.addressline1);
            setValue1("billingToAddressLine2", val?.addressline2);
            setValue1("billingToCity", val?.city);
            setValue1("billingToState", val?.statename);
            setValue1("billingToCountry", val?.name);
            setValue1("billingToZip", val?.zip);
            setIsBillFieldsEditable(false);
            setIsPopoverVisibleDealerBill(false);
            setBillDealerSearched(false); 
            refreshStatesFor(val?.name, setStatesListData); 
            if (isSameAddress) {
                setShipCntctNm(dealerName);
                setShipContactId(dealerId);
                setShippingCountryCode(val?.phone ? val?.countrycode || "" : "");
                setValue1("shippingToName", dealerName);
                setValue1("shippingToBusinessName", val?.businessname);
                setValue1("shippingToPhoneNo", val?.phone);
                setValue1("shippingToEmail", val?.email);
                setValue1("shippingToAddressLine1", val?.addressline1);
                setValue1("shippingToAddressLine2", val?.addressline2);
                setValue1("shippingToCity", val?.city);
                setValue1("shippingToState", val?.statename);
                setValue1("shippingToCountry", val?.name);
                setValue1("shippingToZip", val?.zip);
                setIsShipFieldsEditable(false);
                refreshStatesFor(val?.name, setShippingStatesListData);
            }
        } else {
            setShipCntctNm(dealerName);
            setShipContactId(dealerId);
            // setShipDealerAccountId(val?.accountid || val?.contactid || null);
            // setShipDealerUserId(val?.userid || null);
            setShippingCountryCode(val?.phone ? val?.countrycode || "" : "");
            setValue1("shippingToName", dealerName);
            setValue1("shippingToBusinessName", val?.businessname);
            setValue1("shippingToPhoneNo", val?.phone);
            setValue1("shippingToEmail", val?.emailid);
            setValue1("shippingToAddressLine1", val?.addressline1);
            setValue1("shippingToAddressLine2", val?.addressline2);
            setValue1("shippingToCity", val?.city);
            setValue1("shippingToState", val?.statename);
            setValue1("shippingToCountry", val?.name);
            setValue1("shippingToZip", val?.zip);
            setIsShipFieldsEditable(false);
            setIsPopoverVisibleDealerShip(false);
            refreshStatesFor(val?.name, setShippingStatesListData);
        }
    };

    const isBillFieldDisabled = () => {
        if (billContactSearchType === "walk_in") return !isBillFieldsEditable;
        if (billContactSearchType === "dealer") return true;
        return true;
    };
    const isShipFieldDisabled = () => {
        if (isSameAddress) return true;
        if (isOnetimeShippingAddress) return false;
        if (shipContactSearchType === "walk_in") return !isShipFieldsEditable;
        if (shipContactSearchType === "dealer") return true;
        return true;
    };

    const clearSearchInput = () => {
        setModel(null);
        setSerial(null);
        setDesc(null);
        setAnchorEl(null);
        setSearchInputmodelno("");
        setSearchInputserialno("");
        setAnchorTarget(null);
        setModelList([]);
        setSerialList([]);
        setCurrentItem(null);
        setCurrency("USD");
        setDescShrink(false);
        setNoData(false);
        setType(null);
        setISSerialNumberRequired(false);
        setSearchObj((prevState) => ({ ...prevState, searchVal: "" }));
        reset({ modelNumber: null, serialNumber: null, productName: null });
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleShipClose = () => {               
        setShipAnchorEl(null);
    };

    const handleSelection = (val, columnId) => {
        const model =
            val?.model && val?.model !== null
                ? val?.model
                : val?.technical_details?.product_title
                    ? val?.technical_details?.product_title
                    : val?.technical_details?.product_name;
        const product_name =
            val?.model && val?.model !== null
                ? val?.inventory_title
                    ? val?.inventory_title
                    : val?.modelname
                        ? val?.modelname
                        : ""
                : val?.technical_details?.product_title
                    ? val?.technical_details?.product_title
                    : val?.technical_details?.product_name;
        setModel(model);
        setSerial(val?.serialno);
        setpurchaseprice(val?.purchaseprice);
        setprice(val?.purchaseprice);
        setDesc(product_name);
        setImage(
            val?.imagepaths?.front ||
            val?.imagepaths?.back ||
            val?.imagepaths?.left ||
            val?.imagepaths?.right ||
            val?.imagepaths?.wrist_shot ||
            val?.imagepaths?.buckle_closed ||
            val?.imagepaths?.buckle_opened ||
            val?.imagepaths?.free_form ||
            imageNotAvailable
        );
        setQuantity(val?.quantity);
        setType(val?.type);
        setISSerialNumberRequired(false);
        setProductId(val?.productid);
        setAnchorEl(null);
        setAnchorTarget(null);
        setValue("modelNumber", model);
        setValue("serialNumber", val?.serialno);
        setInventoryId(val?.inventoryid);
        setTimeout(() => {
            setValue("productName", product_name);
        }, 100);
        setValue(
            "image",
            val?.imagepaths?.front ||
            val?.imagepaths?.back ||
            val?.imagepaths?.left ||
            val?.imagepaths?.right ||
            val?.imagepaths?.wrist_shot ||
            val?.imagepaths?.buckle_closed ||
            val?.imagepaths?.buckle_opened ||
            val?.imagepaths?.free_form ||
            val?.product_imagepaths?.images ||
            imageNotAvailable
        );
        setDescShrink(product_name ? true : false);
        setSearchObj((prevState) => ({ ...prevState, searchVal: "" }));
        setModelList([]);
        setSerialList([]);
        setSearchInputmodelno("");
        setSearchInputserialno("");
    };

    const clearCntctSearchInput = (type) => {
        if (type === "bill") {
            setNoBillData(false);
            setBillCntctLst([]);
            setBillCntctSearchTxt(null);
            setSearchInput("");
            setBillCntctNm(null);
            setBillContactId(null);
            setBillingCountryCode("+1");
            if (isSameAddress) {
                setNoShipData(false);
                setShipCntctSearchTxt(null);
                setSearchInputship("");
                setShipCntctNm(null);
                reset1();
                setShipContactId(null);
                setShippingCountryCode("+1");
            } else {
                setValue1("billingToName", null);
                setValue1("billingToBusinessName", null);
                setValue1("billingToPhoneNo", null);
                setValue1("billingToEmail", null);
                setValue1("billingToAddressLine1", null);
                setValue1("billingToAddressLine2", null);
                setValue1("billingToCity", null);
                setValue1("billingToState", null);
                setValue1("billingToCountry", "United States");
                setValue1("billingToZip", null);
            }
        } else {
            setNoShipData(false);
            setShipCntcts([]);
            setSearchInputship("");
            setShipCntctSearchTxt(null);
            setShipCntctNm(null);
            setValue1("shippingToName", null);
            setValue1("shippingToBusinessName", null);
            setValue1("shippingToPhoneNo", null);
            setValue1("shippingToEmail", null);
            setValue1("shippingToAddressLine1", null);
            setValue1("shippingToAddressLine2", null);
            setValue1("shippingToCity", null);
            setValue1("shippingToState", null);
            setValue1("shippingToCountry", "United States");
            setValue1("shippingToZip", null);
            setSameAddress(false);
            setShipContactId(null);
            setShippingCountryCode("+1");
        }
    };

    const onchangeDeposit = (e) => {
        const value = e.target.value.replace(/[^0-9\.]/g, "");
        setDeposit(value);
    };

    const paymentMethod = (e) => {
        setPaymentMethod(e.target.value);
    };
    const handleDealerPushDecision = (isYes) => {
        const isDataPush = isYes ? false : true;
        setDealerPushConfirmOpen(false);
        setIsSubmitInvoice(true);
        props.invoiceDataPush(
            { invoiceId: createdInvoiceId, is_dataPush: isDataPush, type: "Memo" },
            (response) => {
                setIsSubmitInvoice(false);
                if (isYes) {
                    showSuccessToast(
                    "Invoice created and inventory pushed to the buyer's dealer account successfully."
                    );
                } else {
                    showSuccessToast("Creating Memo Invoice using the Dealer.");
                }
                setInvoiceId(createdInvoiceId);
                setCreatedInvoiceId(null);
            },
            (error) => {
                setIsSubmitInvoice(false);
                showErrorToast(
                    error?.response?.data?.message ||
                        "Failed to push inventory to the dealer account."
                );
                setInvoiceId(createdInvoiceId);
                setCreatedInvoiceId(null);
            }
        );
    };
    const handleOpenCreateContactModal = (target) => {
        setCreateContactTarget(target);
        setCreateContactModalOpen(true);
    };

    const handleCreateContactSuccess = (contact) => {
        if (!contact) return;
        if (!contact.contactid) {
            showErrorToast(
                "Contact was created, but it could not be linked to the invoice. Please search and select the new contact."
            );
            return;
        }
        handleContactSelection(contact, createContactTarget || "bill");
    };

    const handleContactSelection = async (val, columnId) => {
        const displayName =`${val?.firstname ?? ""} ${val?.lastname ?? ""}`.trim() ||(val?.businessname || "").trim() || "";
        if (columnId === "bill") {
            setNoBillData(false);
            setBillCntctNm(displayName);
            setBillCntctSearchTxt("");
            setBillCntctLst([]);
            setSearchInput("");
            setSearchInputship("");
            setIsBillFieldsEditable(false);
            if (val.billingcountry) {
                const selectedCountry = val.billingcountry;
                const filterCountry = countryListData.find((country) => country.name === selectedCountry);
                if (filterCountry && filterCountry.id) {
                    getUserdetailsforsubscrption
                        .getAllStateList(filterCountry.id)
                        .then((res) => setStatesListData(res?.data?.data))
                        .catch((error) => showErrorToast(error || "Something went wrong"));
                 }
                }
            
            let phoneNumber = val ? val.phoneno : null;
            if (phoneNumber && val.billingcountry) {
                phoneNumber = phoneNumber.replace(/\W+/g, "");
            }
            setBillingCountryCode(phoneNumber ? val?.phonecountrycode || "" : "");
            setBillContactId(val?.contactid);
            setValue1("billingToName", displayName);
            setValue1("billingToBusinessName", val?.businessname);
            setValue1("billingToPhoneNo", phoneNumber);
            setValue1("billingToEmail", val?.emailid);
            setValue1("billingToAddressLine1", val?.billingaddress1);
            setValue1("billingToAddressLine2", val?.billingaddress2);
            setValue1("billingToCity", val?.billingcity);
            setValue1("billingToState", val?.billingstate);
            setValue1("billingToCountry", val?.billingcountry);
            setValue1("billingToZip", val?.billingzipcode);
            if (isSameAddress) {
                shippingFormPatch(val);
            }
        } else {
            setNoShipData(false);
            setShipCntctSearchTxt("");
            setSearchInputship("");
            setShipCntcts([]);
            setIsPopoverVisibleship(false);
            shippingFormPatch(val);
        }
    };

    const shippingFormPatch = (val) => {
        const displayName =
            `${val?.firstname ?? ""} ${val?.lastname ?? ""}`.trim() ||
            (val?.businessname || "").trim() ||
            "";
        setShipCntctNm(displayName);
        setShipCntctSearchTxt("");
        setSearchInputship("");
        setIsShipFieldsEditable(false);
        console.log(val,"selected shipping")
        if (val.shippingcountry) {
            const selectedCountry = val.shippingcountry;
            const filterCountry = countryListData.find((country) => country.name === selectedCountry);
            if (filterCountry && filterCountry.id) {
                getUserdetailsforsubscrption
                    .getAllStateList(filterCountry.id)
                    .then((res) => setShippingStatesListData(res?.data?.data))
                    .catch((error) => showErrorToast(error || "Something went wrong"));
            }
        }
        let phoneNumber = val ? val.phoneno : null;
        phoneNumber = phoneNumber ? phoneNumber.replace(/\W+/g, "") : null;
        setShippingCountryCode(phoneNumber ? val?.phonecountrycode || "" : "");
        setShipContactId(val?.contactid);
        setValue1("shippingToName", displayName);
        setValue1("shippingToBusinessName", val?.businessname);
        setValue1("shippingToPhoneNo", phoneNumber);
        setValue1("shippingToEmail", val?.emailid);
        setValue1("shippingToAddressLine1", val?.shippingaddress1);
        setValue1("shippingToAddressLine2", val?.shippingaddress2);
        setValue1("shippingToCity", val?.shippingcity);
        setValue1("shippingToState", val?.shippingstate);
        setValue1("shippingToCountry", val?.shippingcountry);
        setValue1("shippingToZip", val?.shippingzipcode);
    };
    const onChangeCounry = (e, id, type = null) => {
        const selectedCountry = e.target.value;
        const filterCountry = countryListData.find(
            (country) => country.name === selectedCountry
        );
        if (type) {
            handleContactSearch(e, id, "bill");
            setValue1(id, selectedCountry);
            if (filterCountry && filterCountry.id) {
                getUserdetailsforsubscrption
                    .getAllStateList(filterCountry.id)
                    .then((res) => {
                        setStatesListData(res?.data?.data);
                    });
            }
        } else {
            setValue1(id, selectedCountry);
            if (filterCountry && filterCountry.id) {
                getUserdetailsforsubscrption
                    .getAllStateList(filterCountry.id)
                    .then((res) => {
                        setShippingStatesListData(res?.data?.data);
                    });
            }
        }
    };

    const handleContactAddress = (val, type) => {
        if (!val || !type) return "";

        const addressFields = type === "bill"
            ? [
                "billingaddress1",
                "billingaddress2",
                "billingcity",
                "billingstate",
                "billingcountry",
                "billingzipcode",
            ]
            : [
                "shippingaddress1",
                "shippingaddress2",
                "shippingcity",
                "shippingstate",
                "shippingcountry",
                "shippingzipcode",
            ];

        const name = `${val?.firstname ?? ""} ${val?.lastname ?? ""}`.trim();
        const fields = [
            name,
            val?.businessname,
            ...addressFields.map((field) => val?.[field]),
        ];

        return fields.filter(Boolean).join(", ");
    };

    const handleDealerAddress = (val) => {
        if (!val) return "";
        const fields = [
            val?.businessname,
            val?.addressline1,
            val?.addressline2,
            val?.city,
            val?.statename,
            val?.name,
            val?.zip,
        ];
        return fields.filter(Boolean).join(", ");
    };

    const handleDescription = (el) => {
        if (el.target.value) {
            setDescShrink(true);
        } else {
            setDescShrink(false);
        }
    };

    const handleGoBack = () => {
        history.push({
            pathname: "/invoices",
            state: { invoiceFilter }
        });
    }

    return (
        <div style={{ backgroundColor: "white" }}>
            <Header />
            <Container
                maxWidth="md"
                style={{ backgroundColor: "white", minHeight: height - 114 + "px" }}
            >
                <form key={1} onSubmit={handleSubmit1(onCreateInvoiceSubmit)}>
                    <Grid container xs={12} sm={12}>
                        <h1 style={{ display: "flex", alignItems: "center" }}>
                            <ArrowBackIcon
                                style={{
                                    color: "action",
                                    paddingRight: "15px",
                                    fontSize: 40,
                                    cursor: "pointer",
                                }}
                                onClick={() => handleGoBack()}
                            >
                                {" "}
                            </ArrowBackIcon>
                            Create Memo invoice
                        </h1>
                    </Grid>
                    <Grid
                        container
                        item
                        xs={12}
                        sm={12}
                        style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                        <Button
                            variant="text"
                            style={{
                                background: "#000",
                                color: "#fff",
                                marginTop: 20,
                                marginBottom: 20,
                            }}
                            onClick={handleAddItem}
                        >
                            Add Item
                        </Button>
                    </Grid>
                    <TableContainer
                        sx={{ maxHeight: 440, marginTop: "20px", marginBottom: "20px" }}
                    >
                        <Table aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    {invoiceObj
                                        .filter(
                                            (item) =>
                                                item.id !== "currency" && item.id !== "modelAndSerial"
                                        )
                                        .map((column) => (
                                            <StyledTableCell
                                                key={column.id}
                                                align={column.align}
                                                style={{ minWidth: column.minWidth }}
                                            >
                                                {column.label}
                                            </StyledTableCell>
                                        ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows?.length === 0 && (
                                    <StyledTableRow>
                                        <TableCell colspan={11} style={{ textAlign: "center" }}>
                                            No record found
                                        </TableCell>
                                    </StyledTableRow>
                                )}
                                {rows?.map((row, idx) => {
                                    return (
                                        <>
                                            <StyledTableRow
                                                hover
                                                role="checkbox"
                                                tabIndex={-1}
                                                key={row.code}
                                            >
                                                {invoiceObj
                                                    ?.filter(
                                                        (item) =>
                                                            item.id !== "currency" &&
                                                            item.id !== "modelAndSerial"
                                                    )
                                                    .map((column) => {
                                                        return (
                                                            <>
                                                                {column.id !== "action" && (
                                                                    <TableCell
                                                                        key={column.id}
                                                                        align={column.align}
                                                                    >
                                                                        {
                                                                            column.type === "image" ? (
                                                                                <img
                                                                                    src={row[column.id]}
                                                                                    width="35"
                                                                                    height="55"
                                                                                />
                                                                            ) : column.id === "rate" ||
                                                                                column.id === "amount" ? (
                                                                                `${rows[idx].currency}${row[column.id]}`
                                                                            ) : column.id === "productName" &&
                                                                                row[column.id]?.length > 50 ? (
                                                                                row[column.id]?.slice(0, 50) + "..."
                                                                            ) : (
                                                                                row[column.id]
                                                                            )
                                                                        }
                                                                    </TableCell>
                                                                )}
                                                                {column.id === "action" && (
                                                                    <TableCell
                                                                        key={column.id}
                                                                        align={column.align}
                                                                        style={{ padding: 10 }}
                                                                    >
                                                                        <EditIcon
                                                                            style={{
                                                                                cursor: "pointer",
                                                                                width: "19px",
                                                                            }}
                                                                            onClick={() => {
                                                                                setModalOpen(!openModal);
                                                                                setAnchorEl(null);
                                                                                const currentItem = rows.at(idx);
                                                                                const {
                                                                                    amount,
                                                                                    currency,
                                                                                    modelNumber,
                                                                                    serialNumber,
                                                                                    type,
                                                                                    purchaseprice,
                                                                                    productId,
                                                                                    productName,
                                                                                    inventoryId,
                                                                                } = currentItem;
                                                                                setCurrentItem(currentItem);
                                                                                setCurrency(currency);
                                                                                reset(currentItem);
                                                                                setEditIdx(idx);
                                                                                setModel(modelNumber);
                                                                                setSerial(serialNumber);
                                                                                setType(type);
                                                                                setprice(purchaseprice);
                                                                                setAmount(amount);
                                                                                setInventoryId(inventoryId);
                                                                                setProductId(productId)
                                                                                setDesc(productName);
                                                                                if (productName) {
                                                                                    setDescShrink(true);
                                                                                }
                                                                            }}
                                                                        />
                                                                        &nbsp;&nbsp;&nbsp;
                                                                        <DeleteIcon
                                                                            style={{
                                                                                cursor: "pointer",
                                                                                width: "19px",
                                                                            }}
                                                                            onClick={() => {
                                                                                handleRemoveSpecificRow(idx);
                                                                            }}
                                                                        />
                                                                    </TableCell>
                                                                )}
                                                            </>
                                                        );
                                                    })}
                                            </StyledTableRow>
                                        </>
                                    );
                                })}
                            </TableBody >
                        </Table >
                    </TableContainer >
                    <Grid container style={{ marginBottom: "20px" }}>
                        <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "flex-start",
                            }}
                        >
                            <div>
                                <div>
                                    <Typography className="color-232323">
                                        <Grid
                                            container
                                            style={{
                                                justifyContent: "flex-start",
                                                alignItems: "center",
                                                height: "42px",
                                            }}
                                        >
                                            <Grid item xs={6} sm={6} md={6}>
                                                <b>BILL TO</b>
                                            </Grid>
                                        </Grid>
                                    </Typography>
                                </div>
                                {billingAddress.map((column) => (
                                    <>
                                        {column.type === "text_search" && (
                                            <>
                                                <div
                                                    className="searchInputs"
                                                    style={{ marginTop: "30px", position: "relative" }}
                                                >
                                                    <FormControl className="form-width-85 margin-t-b-20 margin-p-b-20"
                                                     style={{ marginBottom: "-10px" }}
                                                    >
                                                        {billCntctNm ? (
                                                            <InputLabel
                                                                htmlFor="billCntctNm"
                                                                shrink={true}
                                                                style={{ color: "#424242" }}
                                                            >
                                                                {billContactSearchType === "dealer" ? "Dealer Name" : "Contact Name"}
                                                            </InputLabel>
                                                        ) : null}

                                                        <AntdInput
                                                            id="billCntctNm"
                                                            type="text"
                                                            autoComplete="off"
                                                            ref={inputRef}
                                                            className="invoice-contact-name-input"
                                                            value={billCntctNm || ""}
                                                            placeholder={
                                                                billContactSearchType === "dealer"
                                                                    ? "Dealer Name"
                                                                    : "Contact Name"
                                                            }
                                                            {...register1(column.id, {
                                                                // required: column.required
                                                                //     ? column.errMsg
                                                                    required: false,
                                                            })}
                                                            style={{
                                                                marginBottom: "0px",
                                                                marginTop: billCntctNm ? "10px" : "0px",
                                                                fontSize: "16px",
                                                                paddingLeft: 0,
                                                            }}
                                                            onChange={(e) => {
                                                                handleContactSearch(e, column.id, "bill");
                                                            }}
                                                            bordered={false}
                                                        />
                                                        {errors[column.id] && (
                                                            <span style={{ color: "red" }}>
                                                                {column.errMsg}
                                                            </span>
                                                        )}
                                                        <Divider style={{ marginTop: "5px" }} />
                                                        <div className="contactSearchIcon">
                                                            <Grid container>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    {!isBillTextInput && (
                                                                        <>
                                                                            {!billCntctNm ? (
                                                                                <SearchIcon style={{ cursor: "pointer" }} />
                                                                            ) : (
                                                                                <>
                                                                                    {(billContactSearchType === "dealer" ? fieldLoaderDealerBill : fieldLoaderBill) ? (
                                                                                        <CircularProgress style={{ width: "25px", height: "25px" }} />
                                                                                    ) : (
                                                                                        <CloseIcon id="clearBtn" onClick={() => clearCntctSearchInput("bill")} style={{ cursor: "pointer" }} />
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </Grid>
                                                            </Grid>
                                                        </div>
                                                    </FormControl>
                                                    {billContactSearchType !== "dealer" && (billCntcts &&
                                                        billCntcts.length > 0 &&
                                                        searchInput.length > 0 ? (
                                                        <div
                                                            style={{
                                                                marginLeft: "-70px",
                                                                marginTop: "40px",
                                                            }}
                                                        >
                                                            <AntdPopover
                                                                id={column.id}
                                                                visible={isPopoverVisiblebill}
                                                                content={
                                                                    <div
                                                                        style={{
                                                                            maxHeight: "200px",
                                                                            overflow: "auto",
                                                                        }}
                                                                    >
                                                                        {billCntcts
                                                                            .map((el, index) => {
                                                                                return (
                                                                                    <AccordionDetails
                                                                                        key={index}
                                                                                    >
                                                                                        <Typography
                                                                                            style={{
                                                                                                cursor:
                                                                                                    "pointer",
                                                                                            }}
                                                                                            onClick={() =>
                                                                                                handleContactSelection(
                                                                                                    el,
                                                                                                    "bill"
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            {handleContactAddress(
                                                                                                el, "bill"
                                                                                            )}
                                                                                        </Typography>
                                                                                    </AccordionDetails>
                                                                                );
                                                                            })}
                                                                    </div>
                                                                }
                                                                trigger="click"
                                                                placement="bottomRight"
                                                                onVisibleChange={handleVisibleChange}
                                                            >
                                                                <div
                                                                    style={{
                                                                        width: 0,
                                                                        height: 0,
                                                                        position: "absolute",
                                                                    }}
                                                                />
                                                            </AntdPopover>
                                                        </div>
                                                    ) : billContactSearchType !== "walk_in" &&
                                                        billCntctSearchTxt?.length > 2 &&
                                                        billCntcts?.length == 0 &&
                                                        !fieldLoaderBill &&
                                                        (dataset == 0 || !dataset.length) ? (
                                                        <>
                                                            <AntdPopover
                                                                id={column.id}
                                                                visible={
                                                                    billCntctSearchTxt?.length > 2 &&
                                                                    billCntcts?.length == 0 &&
                                                                    (dataset == 0 || !dataset.length)
                                                                }
                                                                content={
                                                                    <div style={{ overflow: "auto" }}>
                                                                        <a
                                                                            className="dataItem"
                                                                            href="javascript:void(0)"
                                                                            onClick={() =>
                                                                                handleOpenCreateContactModal("bill")
                                                                            }
                                                                            style={{
                                                                                cursor: "pointer",
                                                                                textDecoration: "underline",
                                                                                fontWeight: "bold",
                                                                            }}
                                                                        >
                                                                            Click here to Create New Contact
                                                                        </a>
                                                                    </div>
                                                                }
                                                                trigger="click"
                                                                placement="bottomRight"
                                                                overlayStyle={{ marginTop: "5px" }}
                                                            >
                                                                <div style={{ position: "relative" }} />
                                                            </AntdPopover>
                                                        </>
                                                    ) : null)}
                                                    {billContactSearchType === "dealer" && billCntctSearchTxt?.length > 2 && (
                                                        <div style={{ marginLeft: "-70px", marginTop: "40px" }}>
                                                            <AntdPopover
                                                                id="billDealerPopover"
                                                                visible={isPopoverVisibleDealerBill}
                                                                content={
                                                                    <div style={{ overflow: "auto" }}>
                                                                        {fieldLoaderDealerBill ? (
                                                                            <AccordionDetails style={{ display: "flex", justifyContent: "center" }}>
                                                                                <CircularProgress style={{ width: "20px", height: "20px" }} />
                                                                            </AccordionDetails>
                                                                        ) : dealerListBill.length > 0 ? (
                                                                            dealerListBill.map((el, index) => (
                                                                                <AccordionDetails key={index}>
                                                                                    <Typography style={{ cursor: "pointer" }} onClick={() => handleDealerSelection(el, "bill")}>
                                                                                        {handleDealerAddress(el)}
                                                                                    </Typography>
                                                                                </AccordionDetails>
                                                                            ))
                                                                        ) : billDealerSearched ? (
                                                                            <AccordionDetails>
                                                                                <Typography>No dealers found</Typography>
                                                                            </AccordionDetails>
                                                                        ) : null}
                                                                    </div>
                                                                }
                                                                trigger="click"
                                                                placement="bottomRight"
                                                                onVisibleChange={setIsPopoverVisibleDealerBill}
                                                            >
                                                                <div style={{ width: 0, height: 0, position: "absolute" }} />
                                                            </AntdPopover>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                        {column.type !== "text_search" && (
                                            <FormControl className="form-width-85 margin-t-b-20 margin-p-b-20">
                                                {column.id !== "billingContactType" &&
                                                    <>
                                                        {watch1(column.id) ? (
                                                            <InputLabel
                                                                shrink={true}
                                                                htmlFor="component-simple"
                                                                style={{ color: "#818080" }}
                                                            >
                                                                {column.label}
                                                            </InputLabel>
                                                        ) : (
                                                            <InputLabel
                                                                htmlFor="component-simple"
                                                                style={{ color: "#424242" }}
                                                            >
                                                                {column.label}
                                                            </InputLabel>
                                                        )}
                                                    </>}
                                                {column.type === "select" &&
                                                    column.id === "billingToState" && (
                                                        <Select
                                                            labelId="demo-simple-select-outlined-label"
                                                            id="demo-simple-select-outlined"
                                                            value={
                                                                getValues1()[column.id]
                                                                    ? getValues1()[column.id]
                                                                    : ""
                                                            }
                                                            {...register1(column.id)}
                                                            onChange={(e) => {
                                                                setValue1(column.id, e.target.value);
                                                            }}
                                                            disabled={isBillFieldDisabled()}
                                                        >
                                                            {statesListData &&
                                                                statesListData.map((state) => (
                                                                    <MenuItem key={state.id} value={state.name}>
                                                                        {state.name}
                                                                    </MenuItem>
                                                                ))}
                                                        </Select>
                                                    )}
                                                {column.type === "select" &&
                                                    column.id === "billingToCountry" && (
                                                        <Select
                                                            labelId="demo-simple-select-outlined-label"
                                                            id="demo-simple-select-outlined"
                                                            value={
                                                                getValues1()[column.id]
                                                                    ? getValues1()[column.id]
                                                                    : "United States"
                                                            }
                                                            {...register1(column.id)}
                                                            onChange={(e) => {
                                                                onChangeCounry(e, column.id, "bill");
                                                            }}
                                                            disabled={isBillFieldDisabled()}
                                                        >
                                                            {countryListData &&
                                                                countryListData.map((Country) => (
                                                                    <MenuItem
                                                                        key={Country.id}
                                                                        value={Country.name}
                                                                    >
                                                                        {Country.name}
                                                                    </MenuItem>
                                                                ))}
                                                        </Select>
                                                    )}
                                                {column.type === "phone" && (
                                                    <>
                                                        <Grid container>
                                                            <Grid item xs={2}>
                                                                <Select
                                                                    labelId="demo-simple-select-outlined-label"
                                                                    id="demo-simple-select-outlined"
                                                                    key={column.id}
                                                                    value={
                                                                        billingCountryCode
                                                                            ? billingCountryCode
                                                                            : ""
                                                                    }
                                                                    onChange={(e) => {
                                                                        setBillingCountryCode(e.target.value);
                                                                        if (isSameAddress) {
                                                                            setShippingCountryCode(e.target.value);
                                                                        }
                                                                    }}
                                                                    disabled={isBillFieldDisabled()}
                                                                >
                                                                    <MenuItem value=""></MenuItem>
                                                                    {UniqueCountryCode &&
                                                                        UniqueCountryCode.map((Country) => (
                                                                            <MenuItem key={Country} value={Country}>
                                                                                {`${Country}`}
                                                                            </MenuItem>
                                                                        ))}
                                                                </Select>
                                                            </Grid>
                                                            <Grid item xs={10}>
                                                                <Input
                                                                    id="component-simple"
                                                                    style={{
                                                                        marginBottom: "10px",
                                                                        width: "100%",
                                                                        marginLeft: "10px",
                                                                    }}
                                                                    {...register1(column.id, {
                                                                        pattern: {
                                                                            value: /^(?!0+$)[0-9]{1,14}$/,
                                                                            message: "Invalid phone number",
                                                                        },
                                                                    })}
                                                                    placeholder="Enter your phone number"
                                                                    inputProps={{
                                                                        type: column.type,
                                                                        maxLength: 14,
                                                                        autoComplete: "off",
                                                                    }}
                                                                    onKeyPress={(event) => {
                                                                        if (!/^\d+$/.test(event.key)) {
                                                                            event.preventDefault();
                                                                        }
                                                                    }}
                                                                    onChange={(e) => {
                                                                        handleContactSearch(e, column.id, "bill");
                                                                    }}
                                                                    disabled={isBillFieldDisabled()}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </>
                                                )}
                                                {column.type === "email" && (
                                                    <Input
                                                        id="component-simple"
                                                        key={column.id}
                                                        style={{ marginBottom: "10px" }}
                                                        {...register1(column.id, {
                                                            pattern: {
                                                                value: /\S+@\S+\.\S+/,
                                                                message: "Invalid email address",
                                                            },
                                                        })}
                                                        inputProps={{
                                                            type: column.type,
                                                            autoComplete: "off",
                                                        }}
                                                        onChange={(e) => {
                                                            handleContactSearch(e, column.id, "bill");
                                                        }}
                                                        disabled={isBillFieldDisabled()}
                                                    />
                                                )}
                                                {column.type === "number" && (
                                                    <Input
                                                        id="component-simple"
                                                        key={column.id}
                                                        style={{ marginBottom: "10px" }}
                                                        {...register1(column.id, {
                                                        })}
                                                        onKeyPress={(event) => {
                                                            if (!/^[A-Za-z\d\-_\s]$/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                        onChange={(e) => {
                                                            handleContactSearch(e, column.id, "bill");
                                                        }}
                                                        disabled={isBillFieldDisabled()}
                                                    />
                                                )}
                                                {column.type === "contact_type_select" && (
                                                    <div style={{ marginTop: "10px", marginBottom: "8px" }}>
                                                        <Box
                                                            onClick={handleClick}
                                                             sx={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "center",
                                                                gap: "4px",           
                                                                width: "fit-content",
                                                                cursor: "pointer",
                                                                marginBottom: "-20px",
                                                                }}
                                                        >
                                                            <p sx={{ fontSize: "13px" }}>
                                                                {billContactSearchType === "dealer"
                                                                    ? "Include WatchOps Dealer"
                                                                    : billContactSearchType === "walk_in"
                                                                    ? "Include Walk-In / Temporary Customers"
                                                                    : "Include Business / Retail Contacts"}
                                                            </p>

                                                            {billMenuOpen ? (
                                                                <KeyboardArrowUpIcon fontSize="small" />
                                                            ) : (
                                                                <KeyboardArrowDownIcon fontSize="small" />
                                                            )}
                                                        </Box>
                                                        <Menu
                                                         anchorEl={anchorEl}
                                                         open={open}
                                                         onClose={handleClose}
                                                        >
                                                         <MenuItem 
                                                           style={{ fontSize: "13px" }}
                                                           onClick={() => {
                                                            handleContactSearchTypeChange("other_option", "bill");
                                                            handleClose();
                                                           }}
                                                         >
                                                          Include Business / Retail Contacts
                                                         </MenuItem>
                                                         <MenuItem
                                                           style={{ fontSize: "13px", color: "#646363" }}
                                                           onClick={() => {
                                                            handleContactSearchTypeChange("walk_in", "bill");
                                                            handleClose();
                                                           }}
                                                         >
                                                          Include Walk-In / Temporary Customers
                                                         </MenuItem>
                                                         <MenuItem
                                                           style={{ fontSize: "13px", color: "#646363",display: "none" }}
                                                           onClick={() => {
                                                            handleContactSearchTypeChange("dealer", "bill");
                                                            handleClose();
                                                           }}
                                                         >
                                                           Include WatchOps Dealer
                                                         </MenuItem>
                                                         </Menu>   
                                                         {contactValidationError && (
                                                            <div
                                                                style={{
                                                                    color: "#d32f2f",
                                                                    fontSize: "12px",
                                                                    marginTop: "6px",
                                                                    lineHeight: "18px",
                                                                }}
                                                            >
                                                                {contactValidationError}
                                                            </div>
                                                         )}
                                                    </div>
                                                )}
                                                {column.type === "text" && (
                                                    <Input
                                                        id="component-simple"
                                                        key={column.id}
                                                        style={{ marginBottom: "10px" }}
                                                        {...register1(column.id, {
                                                        })}
                                                        inputProps={{
                                                            type: column.type,
                                                            autoComplete: "off",
                                                        }}
                                                        onChange={(e) => {
                                                            handleContactSearch(e, column.id, "bill");
                                                        }}
                                                        disabled={isBillFieldDisabled()}
                                                    />
                                                )}
                                                {errors1[column.id] && errors1[column.id]?.message && (
                                                    <span style={{ color: "red" }}>
                                                        {errors1[column.id].message}
                                                    </span>
                                                )}
                                            </FormControl>
                                        )}
                                    </>
                                ))}
                            </div>
                        </Grid>
                        <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "flex-end",
                            }}
                        >
                            <div>
                                <div>
                                    <Typography className="color-232323">
                                        <Grid container>
                                            <Grid item xs={6} sm={6} md={6}>
                                                <b>SHIP TO</b>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                justifyContent="flex-end"
                                            >
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name="checkedB1"
                                                            className="float-right"
                                                            onChange={handleSameaddressCheck}
                                                            checked={isSameAddress === true}
                                                        />
                                                    }
                                                    label="Same as bill address"
                                                />
                                            </Grid>
                                        </Grid>
                                    </Typography>
                                </div>
                                {shippingAddress.map((column, i) => (
                                    <>
                                        {column.type === "text_search" && (
                                            <>
                                                <div className="searchInputs">
                                                    <FormControl className="form-width-85 margin-t-b-20 margin-p-b-20"
                                                     style={{ marginBottom: "-10px" }}
                                                    >
                                                        {shipCntctNm ? (
                                                            <InputLabel
                                                                htmlFor="shipCntctNm"
                                                                shrink={true}
                                                                style={{ color: "#424242" }}
                                                            >
                                                                {shipContactSearchType === "dealer" ? "Dealer Name" : "Contact Name"}
                                                            </InputLabel>
                                                        ) : null}

                                                        <AntdInput
                                                            id="shipCntctNm"
                                                            type="text"
                                                            autoComplete="off"
                                                            ref={shipinputRef}
                                                            className="invoice-contact-name-input"
                                                            value={shipCntctNm || ""}
                                                            placeholder={
                                                                shipContactSearchType === "dealer"
                                                                    ? "Dealer Name"
                                                                    : "Contact Name"
                                                            }
                                                            disabled={isSameAddress}
                                                            {...register1(column.id, {
                                                                // required: (column.required && billContactSearchType !== "dealer")
                                                                //     ? column.errMsg
                                                                    required: false,
                                                            })}
                                                            style={{
                                                                marginBottom: "0px",
                                                                marginTop: shipCntctNm ? "10px" : "0px",
                                                                fontSize: "16px",
                                                                paddingLeft: 0,
                                                            }}
                                                            onChange={(e) => {
                                                                handleContactSearch(e, column.id, "ship");
                                                            }}
                                                            bordered={false}
                                                        />
                                                        {errors[column.id] && (
                                                            <span style={{ color: "red" }}>
                                                                {column.errMsg}
                                                            </span>
                                                        )}
                                                        <Divider style={{ marginTop: "5px" }} />
                                                        <div className="contactSearchIcon">
                                                            <Grid container>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    {!isShipTextInput && (
                                                                        <>
                                                                            {!shipCntctNm ? (
                                                                                <SearchIcon
                                                                                    style={{
                                                                                        cursor: isSameAddress ? "default" : "pointer",
                                                                                        opacity: isSameAddress ? 0.5 : 1,
                                                                                    }}
                                                                                />
                                                                            ) :
                                                                                (
                                                                                    <>
                                                                                        {fieldLoaderShip ? (
                                                                                            <CircularProgress style={{ width: "25px", height: "25px" }} />
                                                                                        ) : (
                                                                                            !isSameAddress && (
                                                                                                <CloseIcon
                                                                                                    id="clearBtn"
                                                                                                    onClick={() => {
                                                                                                        clearCntctSearchInput("ship");
                                                                                                    }}
                                                                                                    style={{ cursor: "pointer" }}
                                                                                                />
                                                                                            )
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                        </>
                                                                    )}
                                                                </Grid>
                                                            </Grid>
                                                        </div>
                                                    </FormControl>
                                                    {shipContactSearchType !== "dealer" && !isOnetimeShippingAddress && (shipCntcts &&
                                                        shipCntcts.length > 0 &&
                                                        searchInputship.length > 0 ? (
                                                        <div
                                                            style={{
                                                                marginLeft: "-70px",
                                                                marginTop: "40px",
                                                            }}
                                                        >
                                                            <AntdPopover
                                                                id={column.id}
                                                                visible={isPopoverVisibleship}
                                                                content={
                                                                    <div
                                                                        style={{
                                                                            height: shipCntcts.length < 4 ? "auto" : "200px",
                                                                            overflow: "auto",
                                                                        }}
                                                                    >
                                                                        {shipCntcts
                                                                            .map((el, index) => {
                                                                                return (
                                                                                    <AccordionDetails
                                                                                        key={index}
                                                                                    >
                                                                                        <Typography
                                                                                            style={{
                                                                                                cursor:
                                                                                                    "pointer",
                                                                                            }}
                                                                                            onClick={() =>
                                                                                                handleContactSelection(
                                                                                                    el,
                                                                                                    "ship"
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            {handleContactAddress(
                                                                                                el, "ship"
                                                                                            )}
                                                                                        </Typography>
                                                                                    </AccordionDetails>
                                                                                );
                                                                            })}
                                                                    </div>
                                                                }
                                                                trigger="click"
                                                                placement="bottomRight"
                                                                onVisibleChange={handleVisibleChangeship}
                                                            >
                                                                <div
                                                                    style={{
                                                                        width: 0,
                                                                        height: 0,
                                                                        position: "absolute",
                                                                    }}
                                                                />
                                                            </AntdPopover>
                                                        </div>)
                                                        :
                                                        (!isOnetimeShippingAddress && shipContactSearchType !== "walk_in"
                                                            && searchInputship?.length > 2
                                                            && shipCntcts?.length == 0
                                                            && !fieldLoaderShip
                                                            && (shippingdataset == 0 || !shippingdataset.length)) ?
                                                            <AntdPopover
                                                                id={column.id}
                                                                visible={searchInputship?.length > 2
                                                                    && shipCntcts?.length == 0
                                                                    && (shippingdataset == 0 || !shippingdataset.length)}
                                                                content={
                                                                    <div
                                                                        style={{ overflow: "auto" }}
                                                                    >
                                                                        <a
                                                                            className="dataItem"
                                                                            onClick={() =>
                                                                                handleOpenCreateContactModal("ship")
                                                                            }
                                                                            style={{ cursor: "pointer", textDecoration: 'underline', fontWeight: 'bold' }}
                                                                        >
                                                                            Click here to Create New Contact
                                                                        </a>
                                                                    </div>
                                                                }
                                                                trigger="click"
                                                                placement="bottomRight"
                                                                overlayStyle={{ marginTop: "5px" }}
                                                            >
                                                                <div
                                                                    style={{ position: "relative" }}
                                                                />
                                                            </AntdPopover>
                                                            : null
                                                    )}
                                                    {shipContactSearchType === "dealer" && !isOnetimeShippingAddress && shipCntctSearchTxt?.length > 2 && (
                                                        <div style={{ marginLeft: "-70px", marginTop: "40px" }}>
                                                            <AntdPopover
                                                                id="shipDealerPopover"
                                                                visible={isPopoverVisibleDealerShip}
                                                                content={
                                                                    <div style={{ overflow: "auto" }}>
                                                                        {dealerListShip.length > 0 ? (
                                                                            dealerListShip.map((el, index) => (
                                                                                <AccordionDetails key={index}>
                                                                                    <Typography
                                                                                        style={{ cursor: "pointer" }}
                                                                                        onClick={() => handleDealerSelection(el, "ship")}
                                                                                    >
                                                                                        {handleDealerAddress(el)}
                                                                                    </Typography>
                                                                                </AccordionDetails>
                                                                            ))
                                                                        ) : (
                                                                            <AccordionDetails>
                                                                                <Typography>No dealers found</Typography>
                                                                            </AccordionDetails>
                                                                        )}
                                                                    </div>
                                                                }
                                                                trigger="click"
                                                                placement="bottomRight"
                                                                onVisibleChange={setIsPopoverVisibleDealerShip}
                                                            >
                                                                <div style={{ width: 0, height: 0, position: "absolute" }} />
                                                            </AntdPopover>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                        {column.type !== "text_search" && (
                                            <FormControl className="form-width-85 margin-t-b-20 margin-p-b-20">
                                                {column.id !== "shippingContactType" &&
                                                    <>
                                                        {watch1(column.id) ? (
                                                            <InputLabel
                                                                shrink={true}
                                                                htmlFor="component-simple"
                                                                style={{ color: "#818080" }}
                                                            >
                                                                {column.label}
                                                            </InputLabel>
                                                        ) : (
                                                            <InputLabel
                                                                htmlFor="component-simple"
                                                                style={{ color: "#424242" }}
                                                            >
                                                                {column.label}
                                                            </InputLabel>
                                                        )}
                                                    </>}
                                                {column.type === "select" &&
                                                    column.id === "shippingToCountry" && (
                                                        <Select
                                                            labelId="demo-simple-select-outlined-label"
                                                            id="demo-simple-select-outlined"
                                                            value={
                                                                getValues1()[column.id]
                                                                    ? getValues1()[column.id]
                                                                    : "United States"
                                                            }
                                                            {...register1(column.id)}
                                                            onChange={(e) => {
                                                                setValue1(column.id, e.target.value);
                                                                onChangeCounry(e, column.id);
                                                            }}
                                                            disabled={isShipFieldDisabled()}
                                                        >
                                                            {countryListData &&
                                                                countryListData.map((Country) => (
                                                                    <MenuItem
                                                                        key={Country.id}
                                                                        value={Country.name}
                                                                    >
                                                                        {Country.name}
                                                                    </MenuItem>
                                                                ))}
                                                        </Select>
                                                    )}
                                                {column.type === "select" &&
                                                    column.id === "shippingToState" && (
                                                        <Select
                                                            labelId="demo-simple-select-outlined-label-1"
                                                            id="demo-simple-select-outlined-1"
                                                            value={
                                                                getValues1()[column.id]
                                                                    ? getValues1()[column.id]
                                                                    : ""
                                                            }
                                                            {...register1(column.id)}
                                                            onChange={(e) => {
                                                                setValue1(column.id, e.target.value);
                                                            }}
                                                            disabled={isShipFieldDisabled()}
                                                        >
                                                            {!isSameAddress &&
                                                                shippingStatesListData &&
                                                                shippingStatesListData.map((state) => (
                                                                    <MenuItem key={state.id} value={state.name}>
                                                                        {state.name}
                                                                    </MenuItem>
                                                                ))}
                                                            {isSameAddress &&
                                                                statesListData &&
                                                                statesListData.map((state) => (
                                                                    <MenuItem key={state.id} value={state.name}>
                                                                        {state.name}
                                                                    </MenuItem>
                                                                ))}
                                                        </Select>
                                                    )}
                                                {column.type === "phone" && (
                                                    <>
                                                        <Grid container>
                                                            <Grid item xs={2}>
                                                                <Select
                                                                    labelId="demo-simple-select-outlined-label"
                                                                    id="demo-simple-select-outlined"
                                                                    value={
                                                                        shippingCountryCode
                                                                            ? shippingCountryCode
                                                                            : ""
                                                                    }
                                                                    onChange={(e) => {
                                                                        setShippingCountryCode(e.target.value);
                                                                    }}
                                                                    disabled={isShipFieldDisabled()}
                                                                >
                                                                    <MenuItem value=""></MenuItem>
                                                                    {UniqueCountryCode &&
                                                                        UniqueCountryCode.map((Country) => (
                                                                            <MenuItem key={Country} value={Country}>
                                                                                {`${Country}`}
                                                                            </MenuItem>
                                                                        ))}
                                                                </Select>
                                                            </Grid>
                                                            <Grid item xs={10}>
                                                                <>
                                                                    <Input
                                                                        id="component-simple"
                                                                        style={{
                                                                            marginBottom: "10px",
                                                                            width: "100%",
                                                                            marginLeft: "10px",
                                                                        }}
                                                                        {...register1(column.id, {
                                                                            pattern: {
                                                                                value: /^(?!0+$)[0-9]{1,14}$/,
                                                                                message: "Invalid phone number",
                                                                            },
                                                                        })}
                                                                        placeholder="Enter your phone number"
                                                                        inputProps={{
                                                                            type: column.type,
                                                                            maxLength: 14,
                                                                            minlength: 1,
                                                                            autoComplete: "off",
                                                                        }}
                                                                        onKeyPress={(event) => {
                                                                            if (!/^\d+$/.test(event.key)) {
                                                                                event.preventDefault();
                                                                            }
                                                                        }}
                                                                        disabled={isShipFieldDisabled()}
                                                                    />
                                                                </>
                                                            </Grid>
                                                        </Grid>
                                                    </>
                                                )}
                                                {column.type === "email" && (
                                                    <Input
                                                        id="component-simple"
                                                        key={column.id}
                                                        style={{ marginBottom: "10px" }}
                                                        {...register1(column.id, {
                                                            pattern: {
                                                                value: /\S+@\S+\.\S+/,
                                                                message: "Invalid email address",
                                                            },
                                                        })}
                                                        inputProps={{
                                                            type: column.type,
                                                            autoComplete: "off",
                                                        }}
                                                        disabled={isShipFieldDisabled()}
                                                    />
                                                )}
                                                {column.type === "number" && (
                                                    <Input
                                                        id="component-simple"
                                                        key={column.id}
                                                        style={{ marginBottom: "10px" }}
                                                        {...register1(column.id, {
                                                        })}
                                                        onKeyPress={(event) => {
                                                            if (!/^[A-Za-z\d\-_\s]$/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                        disabled={isShipFieldDisabled()}
                                                    />
                                                )}
                                                {column.type === "contact_type_select" && (
                                                    <div style={{ marginTop: "10px", marginBottom: "8px" }}>
                                                        <Box
                                                            onClick={handleShipClick}
                                                            sx={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "center",
                                                                gap: "4px",           
                                                                width: "fit-content",
                                                                cursor: "pointer",
                                                                marginBottom: "-20px",
                                                                }}
                                                        >
                                                            <p sx={{ fontSize: "13px" }}>
                                                                    {isOnetimeShippingAddress
                                                                        ? "One-time Shipping Address"
                                                                        : shipContactSearchType === "dealer"
                                                                        ? "Include WatchOps Dealer"
                                                                        : shipContactSearchType === "walk_in"
                                                                        ? "Include Walk-In / Temporary Customers"
                                                                        : "Include Business / Retail Contacts"}
                                                            </p>
                                                            {shipOpen ? (
                                                                <KeyboardArrowUpIcon fontSize="small" />
                                                            ) : (
                                                                <KeyboardArrowDownIcon fontSize="small" />
                                                            )}
                                                        </Box>
                                                        <Menu
                                                        anchorEl={shipAnchorEl}
                                                        open={shipOpen}
                                                        onClose={handleShipClose}
                                                        >
                                                         <MenuItem 
                                                           style={{ fontSize: "13px" }}
                                                           onClick={() => {
                                                            setSameAddress(false);
                                                            handleContactSearchTypeChange("other_option", "ship");
                                                            handleShipClose();
                                                           }}
                                                         >
                                                          Include Business / Retail Contacts
                                                         </MenuItem>
                                                         <MenuItem
                                                           style={{ fontSize: "13px", color: "#646363" }}
                                                           onClick={() => {
                                                            setSameAddress(false);
                                                            handleContactSearchTypeChange("walk_in", "ship");
                                                            handleShipClose();
                                                           }}
                                                         >
                                                          Include Walk-In / Temporary Customers
                                                         </MenuItem>
                                                         <MenuItem
                                                           style={{ fontSize: "13px", color: "#646363" }}
                                                           onClick={() => {
                                                            setSameAddress(false);
                                                            setIsOnetimeShippingAddress(true);
                                                            setShipContactId(null);
                                                            setIsShipFieldsEditable(true);
                                                            setIsPopoverVisibleship(false);
                                                            setIsPopoverVisibleDealerShip(false);
                                                            handleShipClose();
                                                           }}
                                                         >
                                                          One-time Shipping Address
                                                         </MenuItem>
                                                         </Menu>   
                                                         {shipContactValidationError && (
                                                            <div
                                                                style={{
                                                                    color: "#d32f2f",
                                                                    fontSize: "12px",
                                                                    marginTop: "6px",
                                                                    lineHeight: "18px",
                                                                }}
                                                            >
                                                                {shipContactValidationError}
                                                            </div>
                                                         )}
                                                    </div>
                                                )}
                                                {column.type === "text" && (
                                                    <Input
                                                        id="component-simple"
                                                        key={column.id}
                                                        style={{ marginBottom: "10px" }}
                                                        {...register1(column.id, {
                                                        })}
                                                        inputProps={{
                                                            type: column.type,
                                                            autoComplete: "off",
                                                        }}
                                                        disabled={isShipFieldDisabled()}
                                                    />
                                                )}
                                                {errors1[column.id] &&
                                                    errors1[column.id].message &&
                                                    !isSameAddress && (
                                                        <span style={{ color: "red" }}>
                                                            {errors1[column.id].message}
                                                        </span>
                                                    )}
                                            </FormControl>
                                        )}
                                    </>
                                ))}
                            </div>
                        </Grid>
                    </Grid>
                    {
                        rows.length > 0 ?
                            <Typography variant='h6'>Details</Typography> : null
                    }
                    <TableContainer
                        sx={{ maxHeight: 440, marginTop: "20px", marginBottom: "20px" }}
                    >
                        <Table aria-label="sticky table">
                            <TableBody>
                                {rows.length > 0 && (
                                    <>
                                        <TableRow>
                                            <TableCell colspan={4} style={{ textAlign: "left" }}>
                                                SHIPPING
                                            </TableCell>
                                            <TableCell colspan={3}>
                                                <input
                                                    type="text"
                                                    className="form-width-100"
                                                    {...register1("shippingPrice")}
                                                    placeholder="$0.00"
                                                    style={{ height: "30px" }}
                                                    value={shipping}
                                                    onChange={(e) =>
                                                        setShipping(e.target.value.replace(/[^0-9\.]/g, ""))
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colspan={4} style={{ textAlign: "left" }}>
                                                DISCOUNT
                                            </TableCell>
                                            <TableCell colspan={3}>
                                                <input
                                                    type="text"
                                                    className="form-width-100"
                                                    {...register1("discount")}
                                                    placeholder="$0.00"
                                                    style={{ height: "30px" }}
                                                    value={discount}
                                                    onChange={(e) =>
                                                        setDiscount(e.target.value.replace(/[^0-9\.]/g, ""))
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colspan={4} style={{ textAlign: "left" }}>
                                                TAX
                                            </TableCell>
                                            <TableCell colspan={3}>
                                                <input
                                                    className="form-width-100"
                                                    type="text"
                                                    {...register1("tax")}
                                                    placeholder="$0.00"
                                                    style={{ height: "30px" }}
                                                    value={tax}
                                                    onChange={(e) =>
                                                        setTax(e.target.value.replace(/[^0-9\.]/g, ""))
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colspan={4} style={{ textAlign: "left" }}>
                                                FEES
                                            </TableCell>
                                            <TableCell colspan={3}>
                                                <input
                                                    className="form-width-100"
                                                    type="text"
                                                    {...register1("fees")}
                                                    placeholder="$0.00"
                                                    style={{ height: "30px" }}
                                                    value={fees}
                                                    onChange={(e) =>
                                                        setFees(e.target.value.replace(/[^0-9\.]/g, ""))
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colspan={4} style={{ textAlign: "left" }}>
                                                DEPOSIT
                                            </TableCell>
                                            <TableCell colspan={3}>
                                                <input
                                                    type="text"
                                                    className="form-width-100"
                                                    {...register1("deposit")}
                                                    placeholder="$0.00"
                                                    style={{ height: "30px" }}
                                                    value={deposit}
                                                    onChange={onchangeDeposit}
                                                />
                                            </TableCell>
                                        </TableRow>

                                        <TableRow>
                                            <TableCell colspan={4} style={{ textAlign: "left" }}>
                                                MEMO TERM
                                            </TableCell>
                                            <TableCell colspan={3}>
                                                <Select
                                                    {...register1("terms")}
                                                    defaultValue="Immediate"
                                                    labelId="demo-simple-select-outlined-label"
                                                    id="demo-simple-select-outlined"
                                                    fullWidth
                                                >
                                                    <MenuItem value="Immediate">Immediate</MenuItem>
                                                    <MenuItem value="7 Days">7 Days</MenuItem>
                                                    <MenuItem value="14 Days">14 Days</MenuItem>
                                                    <MenuItem value="21 Days">21 Days</MenuItem>
                                                    <MenuItem value="30 Days">30 Days</MenuItem>
                                                    <MenuItem value="60 Days">60 Days</MenuItem>
                                                    <MenuItem value="90 Days">90 Days</MenuItem>
                                                </Select>
                                            </TableCell>
                                        </TableRow>

                                        <TableRow>
                                            <TableCell colspan={4} style={{ textAlign: "left" }}>
                                                MEMO RETURN DATE
                                            </TableCell>
                                            <TableCell colspan={3}>
                                                <div>
                                                    <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                margin="normal"
                                                                id="date-picker-dialog"
                                                                format="MM/dd/yyyy"
                                                                value={memoReturnDate}
                                                                onChange={(date, e) => {
                                                                    setMemoReturnDate(e);
                                                                }}
                                                                isClearable
                                                                KeyboardButtonProps={{
                                                                    "aria-label": "change date",
                                                                }}
                                                                placeholder="MM/DD/YYYY"
                                                                onPaste={(event) => event.preventDefault()}
                                                                helperText={""}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </FormControl>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colspan={4} style={{ textAlign: "left" }}>
                                                SHIPPING DATE
                                            </TableCell>
                                            <TableCell colspan={3}>
                                                <div>
                                                    <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                margin="normal"
                                                                id="date-picker-dialog"
                                                                format="MM/dd/yyyy"
                                                                value={shippingDate}
                                                                onChange={(date, e) => {
                                                                    setShippingDate(e);
                                                                }}
                                                                isClearable
                                                                KeyboardButtonProps={{
                                                                    "aria-label": "change date",
                                                                }}
                                                                placeholder="MM/DD/YYYY"
                                                                onPaste={(event) => event.preventDefault()}
                                                                helperText={""}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </FormControl>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colspan={4} style={{ textAlign: "left" }}>
                                                SHIPPING METHOD
                                            </TableCell>
                                            <TableCell colspan={3}>
                                                <Select
                                                    {...register1("shippingMethod")}
                                                    onChange={(e) => setShippingMethod(e.target.value)}
                                                    labelId="demo-simple-select-outlined-label"
                                                    id="demo-simple-select-outlined"
                                                    fullWidth
                                                >
                                                    <MenuItem value="USPS">USPS</MenuItem>
                                                    <MenuItem value="Fedex">Fedex</MenuItem>
                                                    <MenuItem value="UPS">UPS</MenuItem>
                                                    <MenuItem value="Ferrari">Ferrari</MenuItem>
                                                    <MenuItem value="Local Pickup">Local Pickup</MenuItem>
                                                </Select>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colspan={4} style={{ textAlign: "left" }}>
                                                TRACKING NUMBER
                                            </TableCell>
                                            <TableCell colspan={3}>
                                                <input
                                                    className="form-width-100"
                                                    type="text"
                                                    {...register1("trackingNumber")}
                                                    placeholder="Tracking Number"
                                                    style={{ height: "30px" }}
                                                    value={trackingNumber}
                                                    onChange={(e) => setTrackingNumber(e.target.value)}
                                                    maxLength={150}
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colspan={4} style={{ textAlign: "left" }}>
                                                NOTES
                                            </TableCell>
                                            <TableCell colspan={3}>
                                                <input
                                                    className="form-width-100"
                                                    type="text"
                                                    {...register1("notes")}
                                                    placeholder="Notes"
                                                    style={{ height: "30px" }}
                                                    value={notes}
                                                    onChange={(e) => {
                                                        setNotes(e.target.value);
                                                    }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colspan={12} style={{ textAlign: "left", gap: "30px" }}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name="checkedB1"
                                                            className="float-right"
                                                            checked={wireDetails}
                                                            value={wireDetails}
                                                            onChange={onChangeOfCheckBox}
                                                        />
                                                    }
                                                label={<p style={{ fontSize: "14px" }}>&nbsp;Include Wire Details</p>}
                                                            />
                                                              <FormControlLabel
                                                                control={
                                                                  <Checkbox
                                                                    name="checkedB1"
                                                                    className="float-right"
                                                                    checked={zelleDetails}
                                                                    value={zelleDetails}
                                                                    onChange={onChangeOfCheckBoxZelle}
                                                                  />
                                                                }
                                                              label={<p style={{ fontSize: "14px" }}>&nbsp;Include Zelle Details</p>}
                                                            />
                                                              <FormControlLabel
                                                                control={
                                                                  <Checkbox
                                                                    name="checkedB1"
                                                                    className="float-right"
                                                                    checked={venmoDetails}
                                                                    value={venmoDetails}
                                                                    onChange={onChangeOfCheckBoxVenmo}
                                                                  />
                                                }
                  label={<p style={{ fontSize: "14px" }}>&nbsp;Include Venmo Details</p>}
                                                    />
                                             <FormControlLabel
                                              control={
                                               <Checkbox
                                                  name="checkedB1"
                                                  className="float-right"
                                                  checked={shippingDetails}
                                                  value={shippingDetails}
                                                  onChange={onChangeOfCheckBoxShipping}
                                                />
                                               }
                                                label={<p style={{ fontSize: "14px" }}>&nbsp;Include Shipping Details</p>}
                                             />
                                            </TableCell>
                                        </TableRow>
                                    </>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {
                        isSubmitInvoice && (
                            <div class="d-spinner">
                                <SpinnerRoundFilled
                                    size={51}
                                    thickness={125}
                                    speed={80}
                                    color="rgba(57, 107, 172, 1)"
                                    className="spp"
                                    enabled={isSubmitInvoice}
                                />
                            </div>
                        )
                    }
                    {
                        !isSubmitInvoice && rows.length > 0 && (
                            <Grid
                                container
                                item
                                xs={12}
                                sm={12}
                                style={{ display: "flex", justifyContent: "flex-end" }}
                            >
                                {walkInValidationError && (
                                    <div style={{ color: "red", marginBottom: 8, textAlign: "right" }}>
                                        {walkInValidationError}
                                    </div>
                                )}
                                <Button
                                    type="submit"
                                    variant="text"
                                    style={{
                                        background: "#000",
                                        color: "#fff",
                                        float: "right",
                                        marginTop: 20,
                                        marginBottom: 20,
                                    }}
                                >
                                    Create Memo Invoice
                                </Button>
                            </Grid>
                        )
                    }
                </form >
                <AntdModal
                    open={openModal}
                    footer={null}
                    onCancel={handleCloseModal}
                >
                    <Box>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            {currentItem ? "Edit Item" : "Add Item"}
                        </Typography>
                        <form key={3} onSubmit={handleSubmit(onSubmit)}>
                            {invoiceObj.map((column) => {
                                return (
                                    <>
                                        {column.id === "modelAndSerial" && (
                                            <>
                                                <div className="searchInputs">
                                                    <FormControl className="form-width-100 space-marign-bottom-10">
                                                        <Controller
                                                            name={column.id}
                                                            control={control}
                                                            rules={{
                                                                required:
                                                                    currentItem &&
                                                                        Object.keys(currentItem).length > 0
                                                                        ? false
                                                                        : true,
                                                            }}
                                                            render={({
                                                                field: { onChange, value },
                                                                fieldState: { error },
                                                            }) => (
                                                                <Autocomplete
                                                                    disabled={currentItem}
                                                                    options={invoiceListData?.filter(item => item.sold === 0)}
                                                                    getOptionDisabled={(option) => {
                                                                        return rows.some(
                                                                            (item) =>
                                                                                item.inventoryId === option.inventoryid
                                                                        );
                                                                    }}
                                                                    getOptionLabel={(option) => {
                                                                        const model = option?.model || "";
                                                                        const productTitle = option?.technical_details?.product_title || "";
                                                                        const productName = option?.technical_details?.product_name || "";
                                                                        const productLabel = model || productTitle || productName || "---";
                                                                        const serialNo = option?.serialno || option?.technical_details?.model_number || "---";
                                                                        const inventoryId = option?.inventoryid || "---";
                                                                        return `${productLabel} | ${serialNo} | ${inventoryId}`;
                                                                    }}
                                                                    value={value || null}
                                                                    onChange={(event, newValue) => {
                                                                        onChange(newValue);
                                                                        handleSelection(newValue);
                                                                        if (newValue) {
                                                                            clearErrors(column.id);
                                                                        }
                                                                    }}
                                                                    filterOptions={(options, state) => {
                                                                        if (state.inputValue === "") {
                                                                            return options;
                                                                        }
                                                                        const filtered = options.filter((option) =>
                                                                            option?.model?.toLowerCase().includes(state.inputValue.toLowerCase()) ||
                                                                            option?.technical_details?.product_title?.toLowerCase().includes(state.inputValue.toLowerCase()) ||
                                                                            option?.technical_details?.product_name?.toLowerCase().includes(state.inputValue.toLowerCase()) ||
                                                                            option?.serialno?.toLowerCase().includes(state.inputValue.toLowerCase()) ||
                                                                            option?.technical_details?.model_number?.toLowerCase().includes(state.inputValue.toLowerCase()) ||
                                                                            String(option?.inventoryid)?.toLowerCase().includes(state.inputValue.toLowerCase())
                                                                        );
                                                                        if (filtered.length === 0) {
                                                                            filtered.push({
                                                                                model:
                                                                                    "Click here to create new Inventory item",
                                                                                isNew: true,
                                                                            });
                                                                        }
                                                                        return filtered;
                                                                    }}
                                                                    renderOption={(option) => {
                                                                        if (option.isNew) {
                                                                            return (
                                                                                <ListItem
                                                                                    onClick={() =>
                                                                                        history.push("/create-inventory")
                                                                                    }
                                                                                    component="a"
                                                                                >
                                                                                    Click here to create new Inventory
                                                                                    item
                                                                                </ListItem>
                                                                            );
                                                                        }

                                                                        const model = option?.model || "";
                                                                        const productTitle = option?.technical_details?.product_title || "";
                                                                        const productName = option?.technical_details?.product_name || "";
                                                                        const productLabel = model || productTitle || productName || "---";
                                                                        const serialNo = option?.serialno || option?.technical_details?.model_number || "---";
                                                                        const inventoryId = option?.inventoryid || "---";
                                                                        return `${productLabel} | ${serialNo} | ${inventoryId}`;
                                                                    }}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            variant="standard"
                                                                            label="Search Model | Serial No | Inventory ID"
                                                                            InputLabelProps={{
                                                                                className:
                                                                                    "MuiFormControlLabel-root contact-add-field",
                                                                            }}
                                                                            InputProps={{
                                                                                ...params.InputProps,
                                                                                endAdornment: (
                                                                                    <>
                                                                                        {params.InputProps.endAdornment}
                                                                                        <InputAdornment position="end">
                                                                                            <SearchIcon />
                                                                                        </InputAdornment>
                                                                                    </>
                                                                                ),
                                                                            }}
                                                                        />
                                                                    )}
                                                                />
                                                            )}
                                                        />
                                                    </FormControl>
                                                </div>
                                                {errors[column.id] && (
                                                    <span style={{ color: "red" }}>{column.errMsg}</span>
                                                )}
                                            </>
                                        )}
                                        {column.id === "modelNumber" && (
                                            <>
                                                <div className="searchInputs">
                                                    <FormControl className="form-width-100">
                                                        {modelNo ? (
                                                            <InputLabel
                                                                htmlFor="model"
                                                                shrink={true}
                                                                style={{ color: "#424242" }}
                                                            >
                                                                {column.label}
                                                            </InputLabel>
                                                        ) : (
                                                            <InputLabel
                                                                htmlFor="model"
                                                                shrink={false}
                                                                style={{ color: "#424242" }}
                                                            >
                                                                {column.label}
                                                            </InputLabel>
                                                        )}

                                                        <AntdInput
                                                            readOnly
                                                            id="model"
                                                            type="text"
                                                            autoComplete="off"
                                                            ref={modelinputRef}
                                                            value={modelNo}
                                                            {...register(column.id, {
                                                                required: column.required
                                                                    ? column.errMsg
                                                                    : false,
                                                            })}
                                                            onChange={(e) => {
                                                                handleSearch(e, column.id);
                                                            }}
                                                            style={{
                                                                marginBottom: "0px",
                                                                marginTop: "10px",
                                                                fontSize: "16px",
                                                            }}
                                                            bordered={false}
                                                        />
                                                        <Divider style={{ marginTop: "5px" }} />
                                                    </FormControl>
                                                    {model &&
                                                        model.length > 0 &&
                                                        searchInputmodelno.length > 0 && (
                                                            <div
                                                                style={{
                                                                    marginLeft: "-360px",
                                                                    marginTop: "50px",
                                                                }}
                                                            >
                                                                <AntdPopover
                                                                    id="model"
                                                                    visible={isPopoverVisiblemodelno}
                                                                    onVisibleChange={setIsPopoverVisiblemodelno}
                                                                    content={
                                                                        <div
                                                                            style={{
                                                                                // height: "200px",
                                                                                overflow: "auto",
                                                                            }}
                                                                        >
                                                                            {model?.slice(0, 15).map((value) => (
                                                                                <Typography
                                                                                    key={
                                                                                        value.model && value.model !== null
                                                                                            ? value.model
                                                                                            : value.miscmodal
                                                                                    }
                                                                                    style={{ padding: 10, width: 200 }}
                                                                                    onClick={() =>
                                                                                        handleSelection(
                                                                                            value,
                                                                                            value.model &&
                                                                                                value.model !== null
                                                                                                ? "model"
                                                                                                : "miscmodal"
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    {value.model && value.model !== null
                                                                                        ? value.model
                                                                                        : value?.technical_details
                                                                                            ?.product_title
                                                                                            ? value?.technical_details
                                                                                                ?.product_title
                                                                                            : value?.technical_details
                                                                                                ?.product_name}
                                                                                </Typography>
                                                                            ))}
                                                                        </div>
                                                                    }
                                                                    trigger="click"
                                                                    placement="bottom"
                                                                >
                                                                    <div
                                                                        style={{
                                                                            width: 0,
                                                                            height: 0,
                                                                            position: "absolute",
                                                                        }}
                                                                    />
                                                                </AntdPopover>
                                                            </div>
                                                        )}
                                                </div>
                                                {errors[column.id] && (
                                                    <span style={{ color: "red" }}>{column.errMsg}</span>
                                                )}
                                                {noData && currentSearch === "modelNumber" && (
                                                    <div className="dataResult">
                                                        <a
                                                            className="dataItem"
                                                            onClick={() => {
                                                                props.history.push("/create-inventory");
                                                            }}
                                                        >
                                                            Click here to create new Inventory item
                                                        </a>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                        {column.id === "serialNumber" && (
                                            <>
                                                <div className="searchInputs">
                                                    <FormControl className="form-width-100">
                                                        {serial ? (
                                                            <InputLabel
                                                                htmlFor="model"
                                                                shrink={true}
                                                                style={{ color: "#424242" }}
                                                            >
                                                                {column.label}
                                                            </InputLabel>
                                                        ) : (
                                                            <InputLabel
                                                                htmlFor="model"
                                                                shrink={false}
                                                                style={{ color: "#424242" }}
                                                            >
                                                                {column.label}
                                                            </InputLabel>
                                                        )}

                                                        <AntdInput
                                                            readOnly
                                                            id="model"
                                                            type="text"
                                                            autoComplete="off"
                                                            value={serial}
                                                            ref={serialinputRef}
                                                            {...register(column.id, {
                                                                required:
                                                                    type !== "misc_product"
                                                                        ? column.required
                                                                            ? column.errMsg
                                                                            : false
                                                                        : false,
                                                            })}
                                                            onChange={(e) => {
                                                                handleSearch(e, column.id);
                                                            }}
                                                            style={{
                                                                marginBottom: "0px",
                                                                marginTop: "10px",
                                                                fontSize: "16px",
                                                            }}
                                                            bordered={false}
                                                        />
                                                        <Divider style={{ marginTop: "5px" }} />
                                                    </FormControl>
                                                    {serialList &&
                                                        serialList.length > 0 &&
                                                        searchInputserialno.length > 0 && (
                                                            <div
                                                                style={{
                                                                    marginLeft: "-360px",
                                                                    marginTop: "50px",
                                                                }}
                                                            >
                                                                <AntdPopover
                                                                    id={column.id}
                                                                    visible={isPopoverVisibleserialno}
                                                                    onVisibleChange={setIsPopoverVisibleserialno}
                                                                    content={
                                                                        <div
                                                                            style={{
                                                                                height: "180px",
                                                                                overflow: "auto",
                                                                            }}
                                                                        >
                                                                            {serialList?.slice(0, 15).map((value) => {
                                                                                return (
                                                                                    <Typography
                                                                                        key={value}
                                                                                        style={{ padding: 10, width: 200 }}
                                                                                        onClick={() => {
                                                                                            handleSelection(value, "serial");
                                                                                        }}
                                                                                    >
                                                                                        {value["serialno"]}
                                                                                    </Typography>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    }
                                                                    trigger="click"
                                                                    placement="bottom"
                                                                >
                                                                    <div
                                                                        style={{
                                                                            width: 0,
                                                                            height: 0,
                                                                            position: "absolute",
                                                                        }}
                                                                    />
                                                                </AntdPopover>
                                                            </div>
                                                        )}
                                                </div>
                                                {errors[column.id] ? (
                                                    <span style={{ color: "red" }}>{column.errMsg}</span>
                                                ) : isSerialNumberRequired ? (
                                                    <span style={{ color: "red" }}>
                                                        {"Please Enter Serial No"}
                                                    </span>
                                                ) : (
                                                    <></>
                                                )}
                                                {noData && currentSearch === "serialNumber" && (
                                                    <div className="dataResult">
                                                        <a
                                                            className="dataItem"
                                                            onClick={() => {
                                                                props.history.push("/create-inventory");
                                                            }}
                                                        >
                                                            Click here to create new Inventory item
                                                        </a>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                        {column.id !== "action" &&
                                            (column.type === "text" || column.type === "number") && (
                                                <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                                                    {column.id === "quantity" ? (
                                                        <InputLabel
                                                            shrink={qtyShrink}
                                                            htmlFor="component-simple"
                                                            className="color-292C2F"
                                                        >
                                                            {column.label}
                                                        </InputLabel>
                                                    ) : column.id === "productName" ? (
                                                        <InputLabel
                                                            shrink={descShrink}
                                                            htmlFor="component-simple"
                                                            className="color-292C2F"
                                                        >
                                                            {column.label}
                                                        </InputLabel>
                                                    ) : (
                                                        <InputLabel
                                                            htmlFor="component-simple"
                                                            className="color-292C2F"
                                                        >
                                                            {column.label}
                                                        </InputLabel>
                                                    )}
                                                    <Input
                                                        id={column.id}
                                                        value={
                                                            column.id === "productName"
                                                                ? desc
                                                                : column.id === "quantity"
                                                                    ? quantity
                                                                    : 1
                                                        }
                                                        {...register(column.id, {
                                                            required: column.required ? column.errMsg : false,
                                                        })}
                                                        onChange={handleDescription}
                                                        inputProps={{
                                                            type: column.type,
                                                            autoComplete: "off",
                                                        }}
                                                        readOnly={column.id === "quantity" ? true : false}
                                                        disableUnderline={false}
                                                        disabled={
                                                            column.id === "productName" ? disabled : false
                                                        }
                                                    />
                                                    {errors[column.id] && (
                                                        <span style={{ color: "red" }}>
                                                            {column.errMsg}
                                                        </span>
                                                    )}
                                                </FormControl>
                                            )}
                                        {(column.type === "select" || column.type === "amount") && (
                                            <FormControl
                                                className={`form-width-${column.minWidth} margin-t-b-20 margin-p-b-20`}
                                                style={{
                                                    marginRight: column.type === "select" ? "16px" : 0,
                                                }}
                                            >
                                                <InputLabel
                                                    htmlFor="component-simple"
                                                    className="color-292C2F"
                                                >
                                                    {column.label}
                                                </InputLabel>
                                                {column.type === "select" ? (
                                                    <Select
                                                        labelId="demo-simple-select-outlined-label"
                                                        id="demo-simple-select-outlined"
                                                        value={currency}
                                                        onChange={(e) => {
                                                            setCurrency(e.target.value);
                                                        }}
                                                    >
                                                        <MenuItem value="USD">USD</MenuItem>
                                                        <MenuItem value="HK$">HK$</MenuItem>
                                                        <MenuItem value="Euro">Euro</MenuItem>
                                                        <MenuItem value="AED">AED</MenuItem>
                                                    </Select>
                                                ) : (
                                                    <Input
                                                        id="component-simple"
                                                        {...register(column.id, { required: column.errMsg || true })}
                                                        inputProps={{
                                                            type: column.type,
                                                            maxLength: "15",
                                                            autoComplete: "off",
                                                        }}
                                                        disableUnderline={false}
                                                        value={amount}
                                                        onChange={(e) => {
                                                            const val = e.target.value.replace(
                                                                /[^0-9\.]/g,
                                                                ""
                                                            );
                                                            setAmount(val);
                                                            try {
                                                                setValue && setValue(column.id, val);
                                                            } catch (err) {}
                                                            if (val && val !== "") {
                                                                clearErrors && clearErrors(column.id);
                                                            } else {
                                                                setError && setError(column.id, { type: "manual", message: column.errMsg || "Please Enter Amount" });
                                                            }
                                                        }}
                                                    />
                                                )}
                                                {errors[column.id] && (
                                                    <span style={{ color: "red" }}>{column.errMsg}</span>
                                                )}
                                            </FormControl>
                                        )}
                                    </>
                                );
                            })}
                            <Box style={{ display: "flex", justifyContent: "flex-end" }}>
                                <Button
                                    type="submit"
                                    variant="text"
                                    style={{
                                        background: !noData ? "#000" : "#cccc",
                                        color: "#fff",
                                        marginTop: "20px",
                                        marginRight: "10px",
                                    }}
                                    disabled={noData}
                                >
                                    Submit
                                </Button>
                                &nbsp;
                                <Button
                                    variant="outlined"
                                    onClick={handleCloseModal}
                                    style={{
                                        background: "#fff",
                                        color: "#000",
                                        marginTop: "20px",
                                        paddingTop: "5 !important",
                                        paddingBottom: "5 !important",
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Box>
                        </form>
                    </Box>
                </AntdModal>
                 <AntdModal
                          open={dealerPushConfirmOpen}
                          footer={null}
                          closable={false}
                          centered
                        >
                          <Box style={{ padding: "10px 0" }}>
                            <Typography variant="h6" component="h2" style={{ marginBottom: 16 }}>
                              Push Inventory to Dealer?
                            </Typography>
                            <p style={{ marginBottom: 24, fontSize: 14, color: "#454545" }}>
                              Since the customer is a registered WatchOps Dealer, would you like to push the inventory items from this invoice directly to the buyer's dealer account?
                              <br />Note: <i>This inventory transfer cannot be reversed. Do you want to continue?</i>
                            </p>
                            <Box style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                              <Button
                                variant="outlined"
                                onClick={() => handleDealerPushDecision(false)}
                                style={{ background: "#fff", color: "#000" }}
                              >
                                No
                              </Button>
                              <Button
                                variant="text"
                                onClick={() => handleDealerPushDecision(true)}
                                style={{ background: "#000", color: "#fff" }}
                              >
                                Yes
                              </Button>
                            </Box>
                          </Box>
                 </AntdModal>
            </Container >
            <FooterComponent />
            {
                contactListConfirmationModal && (
                    <ContactListModal
                        open={contactListConfirmationModal}
                        close={handleCloseContactConfirmation}
                        confirm={handleSuccessContactConfirmation}
                        text={modalText}
                    />
                )
            }
            <CreateContactDialog
                open={createContactModalOpen}
                onClose={() => setCreateContactModalOpen(false)}
                onSuccess={handleCreateContactSuccess}
            />
        </div >
    );
}

function mapStateToProps({
    auth,
    InvoiceDetails,
    ModelList,
    BillShipCntctLst,
}) {
    return {
        invoiceDetails: InvoiceDetails.invoiceDetails,
        currentUser: auth.currentUser,
        modelList: ModelList.modelList,
        billShipCntctLst: BillShipCntctLst.billShipCntctLst,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            createMemoInvoiceDetails,
            getModelSerialList,
            getNewModelSerialList,
            checkContactInDB,
            getBillShipContactList,
            getInvoiceNewContactList,
            dataTransferBusinessList,
            invoiceDataPush
        },
        dispatch
    );
}

CreateMemoInvoiceComponent.propTypes = {
    modelList: PropTypes.arrayOf(PropTypes.object).isRequired,
    getModelSerialList: PropTypes.func.isRequired,
    getNewModelSerialList: PropTypes.func.isRequired,
    getBillShipContactList: PropTypes.func.isRequired,
    getInvoiceNewContactList: PropTypes.func.isRequired,
    dataTransferBusinessList: PropTypes.func.isRequired,
    invoiceDataPush: PropTypes.func.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateMemoInvoiceComponent);